import React, { Component, useEffect, useState, useRef } from "react";
import { Container, Col, Row, Tab, Tabs, Nav, Button, Badge, Form, Card, Alert, Modal, Image, Popover, InputGroup, OverlayTrigger, Tooltip, Dropdown, DropdownButton, ToggleButtonGroup, ToggleButton, FormCheck } from 'react-bootstrap';
import Masonry from 'react-masonry-css'
import { useSearchParams, Link } from "react-router-dom";
import { apiCall, PageScroller } from './../../helpers/api'
import { getFilter, setFilter } from './../../helpers/filters'
import { getDifference, getAge, datePickerToEpoch, relativeTimeFormat, withinAgeRange } from './../../helpers/dates'
import { getStatusPill, getDeliveryStatus } from "../../helpers/status";
import { getContributionList } from "../../helpers/socials";
import { getSmallNumber, getPercentage } from "../../helpers/stats";
import { generateDropdown, getCountries, getStates } from "../../helpers/dropdowns";
import AlertModal from "../../components/alerts/alert";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated';
import InboxLoader from "../../components/spinner/InboxLoader";
import { useImageContext } from "../../hooks/useImageContext";
import { getImageUrl, validateImage, compressImage } from "../../helpers/images";
import { getFileUrl, getVideoURL, validateFile } from "../../helpers/files";
import { formatText } from "../../helpers/format";
import { useAuthContext } from "../../hooks/useAuthContext";
import Fade from 'react-bootstrap/Fade';
import Carousel from 'react-bootstrap/Carousel';
import closeIcon from "./../../images/closeIcon.svg";
import settings from './../../images/settings.svg';
import './Campaigns.css';
import NoAccess from "../../images/no-access.png";
import FullPageSpinner from "../../components/spinner/FullPageSpinner";
import Topbar from "../../components/topbar/Topbar";
import filter from './../../images/filter.svg'
import starGrey from './../../images/star-grey.svg'
import starYellow from './../../images/star-yellow.svg'
import Footer from "../../components/footer/Footer";
import info from './../../images/info.svg';
import warning from './../../images/warning-alert.svg';
import blueAlert from './../../images/blue-alert.svg';
import blueProfileCard from './../../images/blue-profilecard.svg';
import blueTick from './../../images/blue-tick.svg';
import social from './../../images/social.svg';
import grayDoubleChecks from './../../images/gray-double-check.svg';
import whiteDoubleChecks from './../../images/white-double-check.svg';
import backArrow from './../../images/back-arrow-blue.svg';
import rightArrow from './../../images/blue-right-arrow.svg';
import sendDark from './../../images/send-dark.svg';
import paperclip from './../../images/paperclip.svg';
import searchBlue from './../../images/search-blue.svg'
import Cross from "../../images/cross.svg";
import Document from "../../images/document.svg";
import Video from "../../images/video.svg";
import unread from "../../images/unread.svg";
import group from "../../images/groups.svg"
import groupClicked from "../../images/blue-groups.svg"
import read from "../../images/read.svg";
import checkGreen from "./../../images/check-green.svg";
import checkGrey from "./../../images/check.svg";
import Avatar from "./../../images/avatar.png";
import messageFilter from "../../images/messageFilter.svg";
import whatsapp from "../../images/whatsapp.png";

class SendMessageForm extends Component {
  constructor() {
    super()
    this.state = {
        message: '',
        attachments: [],
        errors: '',
        useWhatsapp: false,
        sending: false,
        templates: [],
        alert: {"display":"toast","visible":false,"title":"","content":""},
        pendingWhatsappTemplate: null // NEW: track pending template
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.loadTemplates()
  }

  async loadTemplates(){
    var response = await apiCall(`whatsappTemplates`,{ "method" : "GET" });
    if (response["success"]) {
      this.setState({
        templates: response["success"]["whatsappTemplates"]
      });
    }
    else {
      this.setState({
        error: response["failure"]["error"]
      });
    }
  }

  async sendMessage(message) {
    this.setState({sending: true})
    var data = {"sender":this.props.sender,"message":message,"messageType":this.state.useWhatsapp ? "whatsapp" : "text"}
    if (this.props.unblockChat){
      data["unblockChat"] = true
    }
    if (this.props.isBulkMessage){
      var response = await apiCall(`bulkConversation`,{ "method" : "PUT", "data" : { "messageData":data, "conversations":this.props.conversations} });
    }
    else {
      var response = await apiCall(`conversation?id=${this.props.conversationID}`,{ "method" : "PUT", "data" : data });
    }
    if (response["success"]) {
      this.setState({
        message: ''
      })
    }
    else {
      this.setState({
        alert: {"display":"toast","visible":true,"title":"Error sending message","content":response["failure"]["error"],"className":"bg-danger text-background"}
    });
    }
    this.setState({sending: false})
  }

  async uploadAttachments(attachments){
    var failedAttachments = [];
    for (const attachment of attachments){
      const formData = new FormData();
      formData.append("file",attachment.data)
      formData.append("public_id",attachment.metadata.public_id)
      formData.append("api_key",attachment.metadata.api_key)
      formData.append("timestamp",attachment.metadata.timestamp)
      formData.append("signature",attachment.metadata.signature)
      if (attachment.metadata.folder != ""){
        formData.append("folder",attachment.metadata.folder)
      }
      fetch(`${attachment.metadata.target}/${attachment.metadata.resource_type}/upload`, {
        method: "POST",
        body: formData
      }).then(async response => {
        try {
          let responseJSON = await response.json();
          if (response.ok) {
            if (this.props.isBulkMessage){
              var response = await apiCall(`bulkConversation`,{ "method" : "PUT", "data" : { "messageData":{"sender":this.props.sender,"message":{"id":responseJSON.public_id,"source":attachment.metadata.source,"name":attachment.data.name},"messageType":attachment.type}, "conversations":this.props.conversations} });
            }
            else {
              var response = await apiCall(`conversation?id=${this.props.conversationID}`,{ "method" : "PUT", "data" : {"sender":this.props.sender,"message":{"id":responseJSON.public_id,"source":attachment.metadata.source,"name":attachment.data.name},"messageType":attachment.type} });
            }
            if (response["success"]) {
            }
            else {
              this.setState({
                alert: {"display":"toast","visible":true,"title":"Error sending message","content":response["failure"]["error"],"className":"bg-danger text-background"}
              });
            }
          } 
          else {
            failedAttachments.push(attachment)
          }
        } catch (error) {
          failedAttachments.push(attachment)
        }
      })
    }
  }

  async sendWhatsappTemplate(templateName){
    // Instead of sending, set as pending and update message
    this.setState({
      message: "",
      pendingWhatsappTemplate: templateName
    });
  }

  handleChange(e) {
      this.setState({
          message: e.target.value
      })
  }

  async attachFiles(newFiles) {
    var errors = [];
    var files = newFiles.target.files;
    var fileArray = this.state.attachments;
    if (files.length + fileArray.length){
        files = Object.entries(files).slice(0,5-fileArray.length).map(file => file[1]);
    }
    for (var file of files) {
      if (["doc","pdf","docx","rtf","odt"].includes(file.name.split(".").pop())){
        var [validationResult, validationReason] = validateFile(file)
        var tempFile = {"url":URL.createObjectURL(file),"data":file,"metadata":null,"type":"file"}
      }
      else {
        var [validationResult, validationReason] = validateImage(file)
        file = await compressImage(file)
        var tempFile = {"url":URL.createObjectURL(file),"data":file,"metadata":null,"type":"image"}
      }
      if (validationResult){
          var response = await apiCall(`getUploadSignature?folder=attachments&asset_type=${tempFile.type}`,{ "method" : "GET" });
          if (response["success"]) {
            tempFile.metadata = response["success"]["metadata"]
            fileArray.push(tempFile);
          }
      }
      else {
          errors.push(`${file.name} could not be uploaded: ${validationReason}`)
      }
    }
    this.setState({ attachments: fileArray, errors: errors })
}

  removeFile(targetFile){
      var fileArray = this.state.attachments.filter(function(file) {return file.url != targetFile.url });
      this.setState({ attachments: fileArray })
  }

  async handleSubmit(e) {
    e.preventDefault()
    // If a WhatsApp template is pending, send it as a template
    if (this.state.pendingWhatsappTemplate && this.state.useWhatsapp) {
      this.setState({sending: true});
      var response = await apiCall(`conversation?id=${this.props.conversationID}`,{ "method" : "PUT", "data" : {"sender":this.props.sender,"messageType": "whatsappTemplate","message":this.state.pendingWhatsappTemplate} });
      if (!response["success"]) {
        this.setState({
          alert: {"display":"toast","visible":true,"title":"Error sending message","content":response["failure"]["error"],"className":"bg-danger text-background"}
        });
      }
      this.setState({
        sending: false,
        message: '',
        pendingWhatsappTemplate: null
      });
      if (!this.props.isBulkMessage){
        this.props.showConversation(this.props.conversationID,null,false)
      }
      return;
    }
    if (this.state.attachments){
      await this.uploadAttachments(this.state.attachments)
      this.setState({
        attachments: []
    })
    }
    if (this.state.message.length > 0){
      await this.sendMessage(this.state.message)
    }
    if (!this.props.isBulkMessage){
      this.props.showConversation(this.props.conversationID,null,false)
    }
  }

  // Required for hitting enter into the textarea
  handleKeyPress(e,handleSubmit) {
    if(e.keyCode == 13 && e.shiftKey == false) {
      handleSubmit(e)
    }
    else {
      e.target.style.height = "0px"
      e.target.style.height = `${Math.min(e.target.scrollHeight, 120)}px`
    }
  }

  render() {
      // Split into two components: MessageSendButton and MessagePlatformToggle

      // MessageSendButton: handles sending the message or attachments
      const MessageSendButton = ({ onClick, disabled, sending }) => (
        <button
          onClick={onClick}
          disabled={disabled || sending}
          className="btn border-0 bg-background"
          type="submit"
        >
          <img src={sendDark} alt="Send" />
        </button>
      );

      // MessagePlatformToggle: handles toggling between Platform and WhatsApp
      const MessagePlatformToggle = ({ useWhatsapp, setUseWhatsapp }) => (
        <Dropdown>
          <Dropdown.Toggle variant="white" className="btn border-0 bg-background" />
          <Dropdown.Menu>
        <Dropdown.Item
          active={!useWhatsapp}
          onClick={e => {
            e.preventDefault();
            setUseWhatsapp(false);
          }}
        >
          Platform Only
        </Dropdown.Item>
        <Dropdown.Item
          active={useWhatsapp}
          onClick={e => {
            e.preventDefault();
            setUseWhatsapp(true);
          }}
        >
          WhatsApp
        </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );

      return (
        <form onSubmit={this.handleSubmit} className="InboxInput">
          <AlertModal modal={this.state.alert} onClose={() => this.setState({alert: {"display":"toast","visible":false,"title":"","content":""}})} />

          <div className="attachedImages">
        {this.state.attachments.map(attachment => (
          <span key={attachment.url} className="imageWrapper mb-3" >
            {attachment.type == "image" && (
          <>
            <img id={attachment.url} height="60" width="60" className="object-fit-cover rounded border" src={attachment.url} alt={attachment.data.name} title={attachment.data.name} />
            <img className="overlayTopRight" title="Remove attachment" onClick={(e) => this.removeFile(attachment)} src={Cross}/>
          </>
            )}
            {attachment.type == "file" && (
          <>
            <img id={attachment.data.name} height="60" width="60" className="object-fit-cover" src={Document} alt={attachment.data.name} title={attachment.data.name} />
            <img className="overlayTopRight" title="Remove attachment" onClick={(e) => this.removeFile(attachment)} src={Cross}/>
          </>
            )}
          </span>
        ))}
          </div>

          <InputGroup className="align-items-center">
            <div className="grow-wrap">
              {this.state.sending ? (
                <textarea className="form-control border-0" rows="1" readOnly name="text" id="text" placeholder="Sending message..." value=""></textarea>
              ) : (
                <textarea
              className="form-control border-0"
              rows="1"
              placeholder={ (this.state.pendingWhatsappTemplate && this.state.useWhatsapp) ? `Send template to ${this.props.recipient.name}` : `Send message to ${this.props.recipient.name}` }
              autoFocus
              onChange={this.handleChange}
              onKeyDown={(e) => this.handleKeyPress(e,this.handleSubmit)}
              name="text"
              id="text"
              value={this.state.message}
                ></textarea>
              )}
            </div>
            {/* Send Button */}
            <MessageSendButton
              onClick={this.handleSubmit}
              disabled={(this.state.message.length === 0 && this.state.attachments.length === 0) && !(this.state.useWhatsapp && this.state.pendingWhatsappTemplate)}
              sending={this.state.sending}
            />
            {/* Platform Toggle */}
            {this.props.whatsappEnabled && (
              <MessagePlatformToggle
                useWhatsapp={this.state.useWhatsapp}
                setUseWhatsapp={val => this.setState({ useWhatsapp: val, pendingWhatsappTemplate: null })}
              />
            )}
            {/* WhatsApp Template Dropdown */}
            {this.state.useWhatsapp ? (
              <Dropdown>
                <Dropdown.Toggle variant="white" className="btn border-0 bg-background">
              <img className="WhatsappIndicator" src={whatsapp} alt="WhatsApp" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
              {this.state.templates.map(template => (
                <Dropdown.Item key={template._id} onClick={e => {e.preventDefault(); this.sendWhatsappTemplate(template.name);}}>
                  {template.name}
                </Dropdown.Item>
              ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <label htmlFor="attachment-upload" className="mb-0 d-flex align-items-center">
                <a className="btn border-0 bg-background cursor-pointer">
              <img src={paperclip} alt="Attach" />
                </a>
              </label>
              )}
            {this.state.errors && <div className={"text-muted small"}><strong>{this.state.errors}</strong></div>}   
            <Form.Control type="file" id="attachment-upload" multiple accept=".png, .jpg, .jpeg, .webp, .heic, .pdf, .doc, .docx, .rtf" onChange={(e) => this.attachFiles(e)} variant="default" className="fileUploadBtn d-none" />
          </InputGroup>
        </form>
      );
  }
}

class Conversation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      isConversationLoaded: false,
      readCooldown: {},
      filter: { search : "" }
    };
    this.showConversation = this.showConversation.bind(this);
    this.getConversations(this.props.campaignID)
  }

  componentDidMount() {
    this.intervalID = setInterval(() => {
      if (this.props.class.props.conversationID){
        if (this.state.readCooldown > 0) {
          this.setState({
            readCooldown: this.state.readCooldown - 1
          })
        }
        else if (this.props.class.props.conversations.conversation.unreadMessages > 0){
          this.markConversationAsRead(this.props.class.props.conversationID)
        }
        this.getConversation(this.props.class.props.conversationID,null,false,this.props.class.props.conversations.conversation.lastMessageTime)
      }
      var lastMessageTime = Math.max.apply(Math, this.props.class.props.conversations.conversations.map(conversation => conversation.lastMessageTime))
      this.getConversations(this.props.campaignID,false,lastMessageTime)
    }, 10000);
  }

  componentWillUnmount(){
    clearInterval(this.intervalID);
  }

  componentDidUpdate(){
    if (this.state.isConversationLoaded && this.props.class.props.conversationID != this.props.class.props.conversations.conversation._id) {
      this.getConversation(this.props.class.props.conversationID)
    }
  }

  async markConversationAsRead(id){
    var response = await apiCall(`conversation/read?id=${id}`,{ "method" : "PUT", "data" : {"reader":this.props.class.props.conversations.conversation.participants.filter(function(participant) {return participant.hasOwnProperty("me") && participant.me})[0].id} });
    if (response["success"]) {
      this.getConversations(this.props.campaignID,false)
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
  }

  async markAllConversationsAsRead(){
    var response = await apiCall(`conversations/read/all`,{ "method" : "PUT", "data" : {"campaignID": this.props.campaignID}});
    if (response["success"]) {
      this.getConversations(this.props.campaignID,false)
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
    this.props.class.props.setViewMarkAllAsReadModal(false)
  }

  async markConversationAsUnread(id){
    var response = await apiCall(`conversation/unread?id=${id}`,{ "method" : "PUT", "data" : {"reader":this.props.class.props.conversations.conversation.participants.filter(function(participant) {return participant.hasOwnProperty("me") && participant.me})[0].id} });
    if (response["success"]) {
      this.getConversations(this.props.campaignID,false)
      this.setState({
        readCooldown: 3
      })
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
  }

  async muteConversation(id){
    var response = await apiCall(`conversation/mute?id=${id}`,{ "method" : "PUT", "data" : {"muter":this.props.class.props.conversations.conversation.participants.filter(function(participant) {return participant.hasOwnProperty("me") && participant.me})[0].id} });
    if (response["success"]) {
      this.getConversations(this.props.campaignID,false)
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
  }

  async unmuteConversation(id){
    var response = await apiCall(`conversation/unmute?id=${id}`,{ "method" : "PUT", "data" : {"muter":this.props.class.props.conversations.conversation.participants.filter(function(participant) {return participant.hasOwnProperty("me") && participant.me})[0].id} });
    if (response["success"]) {
      this.getConversations(this.props.campaignID,false)
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
  }



  showConversation(id,setChatBox=null,showLoading=true){
    if (setChatBox){
      setChatBox(true);
    }
   
    this.props.class.props.setAutoScroll(true)
    this.props.class.props.setConversationID(id,null,showLoading);
    this.getConversation(id,null,showLoading);
    if (this.state.readCooldown > 0) {
      this.setState({
        readCooldown: this.state.readCooldown - 1
      })
    } else if (this.props.class.props.conversations.conversation.unreadMessages > 0) {
      this.markConversationAsRead(this.props.class.props.conversationID)
    }
  }

  updateConversations(newConversations){
    var existingConversations = this.props.class.props.conversations;
    newConversations.forEach(conversation => {
      var matchingIndex = existingConversations.conversations.findIndex(existingConversation => existingConversation._id == conversation._id)
      if (matchingIndex >= 0) {
        existingConversations.conversations[matchingIndex] = conversation
      }
      else {
        existingConversations.conversations.push(conversation)
      }
    })
    existingConversations.conversations.sort((a,b) => b.lastMessageTime - a.lastMessageTime);
    this.props.class.props.setConversations(existingConversations)
  }

  updateConversation(newMessages,addAfter=false){
    var existingConversations = this.props.class.props.conversations;
    newMessages.forEach(message => {
      var matchingIndex = existingConversations.messages.findIndex(existingMessage => existingMessage._id == message._id)
      if (matchingIndex >= 0) {
        existingConversations.messages[matchingIndex] = message
      }
      else {
        if (addAfter){
          existingConversations.messages.push(message)
        }
        else {
          existingConversations.messages.unshift(message)
        }
      }
    })
    existingConversations.messages.sort((a,b) => b.messageTime - a.messageTime);
    this.props.class.props.setConversations(existingConversations)
  }

  async getConversations(campaignID,showLoading=true,after=null) {
    var conversations = this.props.class.props.conversations; 
    let urlParams = new URLSearchParams(window.location.search);
    urlParams.set('campaignID', campaignID);
    urlParams.set('limit', 1000);
    if (after && Number.isInteger(after)) {
      urlParams.set('after',after);
    }
    if (this.props.class.props.conversationID) {
      urlParams.set('conversationID', this.props.class.props.conversationID);
    }
    var response = await apiCall(`conversations?`+urlParams.toString(),{ "method" : "GET" });
    if (response["success"]) {
      if (after) { 
        this.updateConversations(response["success"]["conversations"]) 
      } else {
        conversations["conversations"] = response["success"]["conversations"];
        var unreadCounter = 0;
        conversations["conversations"].forEach(conversation => {
          conversation.participants.forEach(participant => {
            if (participant.me && participant.hasUnread) {unreadCounter += 1}
          })
        })
        this.props.class.props.setUnreadMessages(unreadCounter)
        if (this.props.class.props.conversationID){
          this.getConversation(this.props.class.props.conversationID,conversations,showLoading)
        } 
        else if (response["success"]["conversations"].length > 0){
          this.getConversation(response["success"]["conversations"][0]._id,conversations,showLoading)
          this.props.class.props.setConversationID(response["success"]["conversations"][0]._id)
        }
      }
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
    this.props.class.props.setConversations(conversations);
    this.setState({
      isLoaded : true
    });
  }

  async getConversation(id,conversations=null,showLoading=true,after=null) {
    if (conversations == null){
      conversations = this.props.class.props.conversations;
    }
    if (showLoading){
      this.setState({
        isConversationLoaded : false
      });
    }
    if (after) {
      var response = await apiCall(`conversation?id=${id}&after=${after}`,{ "method" : "GET" });
    }
    else {
      var response = await apiCall(`conversation?id=${id}`,{ "method" : "GET" });
    }
    if (response["success"]) {
      if (after) { 
        this.updateConversation(response["success"]["messages"])
      } else {
        conversations["conversation"] = response["success"]["conversation"];
        conversations["messages"] = response["success"]["messages"];
      }
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
    this.props.class.props.setConversations({ "conversations" : conversations["conversations"], "conversation" : conversations["conversation"], "messages" : conversations["messages"] });
    if (showLoading){
      this.setState({
        isConversationLoaded : true
      });
    }
  }

  ConversationListItem(conversation){
    var recipient = {"name":"unknown","profileImage":"None"}
    conversation.participants.forEach(function (participant) {
      if (!participant.hasOwnProperty("me")){
        recipient = participant.details // We'll need to handle maybe group conversations in the future? Not sure if really needed...
      }
    })
    return (
      <div>
        <div className={conversation.id == conversation.selectedConversation ? "p-3 inboxCard selected" : "p-3 inboxCard" } onClick={()=>conversation.bulkMessage.visible ? conversation.class.updateBulkMessageRecipients({"recipient":recipient,"conversationID":conversation.id},conversation.bulkMessage.recipients.filter(function(recipient) {return recipient.conversationID == conversation.id}).length == 0) : conversation.class.showConversation(conversation.id,conversation.setChatBox)}>
          {conversation.bulkMessage.visible && (
            <div className="me-3">
              <input type="checkbox" className="form-check-input" checked={conversation.bulkMessage.recipients.filter(function(recipient) {return recipient.conversationID == conversation.id}).length > 0} onChange={(e) => null}></input>
            </div>
          )}
          <div className="pe-3">
            <img src={getImageUrl(conversation.class.props.providers,recipient.profileImage)} width="46px" height="46px" className="object-fit-cover rounded border bg-background" alt={recipient.name} />
          </div>
          <div className="d-flex justify-content-between">
            <div className="brandDetails">
              <div className="d-flex align-items-center pe-3 pe-lg-4 me-4 me-lg-5 mb-1">
                <h6 className="fw-700 mb-0 me-2 text-truncate">{recipient.name}</h6>
                {conversation.bidDetails && (getStatusPill(conversation.bidDetails.state))}
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="text-truncate text-muted small">{typeof(conversation.lastMessage.contents) === "string" ? conversation.lastMessage.contents : <i>An attachment was sent</i>} </div>
                {conversation.unreadMessages > 0 && <Badge bg="primary" className="smaller ms-2 fw-normal">{conversation.unreadMessages}</Badge>}
              </div>
            </div>
            <div className="text-end text-nowrap position-absolute end-0 me-3">
              <div className="text-muted smaller">{relativeTimeFormat(conversation.lastMessage.messageTime*1000,true)}</div>
            </div>
          </div>
        </div>
      </div>
    );}

    updateBulkMessageRecipients(recipient,add){
      var bulkMessage = this.props.class.props.bulkMessage;
      if (add){
        bulkMessage.recipients.push(recipient);
      }
      else {
        bulkMessage.recipients = bulkMessage.recipients.filter(function(existingRecipient) {return existingRecipient.conversationID != recipient.conversationID })
      }
      this.props.class.props.setBulkMessage(bulkMessage)
      this.props.class.props.setUpdateCounter(this.props.class.props.updateCounter + 1)
    }

    toggleBulkMessaging(){
      this.props.class.props.setBulkMessage({"visible":!this.props.class.props.bulkMessage.visible,"recipients":[]})
    }

  ConversationDetailItem(props){
    var recipient = {"name":"unknown","profileImage":"None"}
    var me = {"id":"","name":"unknown","profileImage":"None"}
    var active = false;
    var muted = false;
    var unblockChat = false;
    var participantType = null
    if (props.bulkMessage.visible) {
      recipient = {"name":`${props.bulkMessage.recipients.length} Recipients`,"profileImage":{},"type":"bulk","socials":[]}
      me = {"id":props.class.props.class.props.currentProfile.profile.id,"name":"Me","profileImage":props.class.props.class.props.currentProfile.profile.profileImage}
    }
    else {
      props.participants.forEach(function (participant) {
        if (!participant.hasOwnProperty("me")){
          recipient = participant.details // We'll need to handle maybe group conversations in the future? Not sure if really needed...
          recipient.type = participant.type
          if (props.bidDetails.state == "Pending" && participant.type == "influencer" && participant.active == false) {
            unblockChat = true;
          }
        }
        else {
          me = participant.details
          active = participant.active
          muted = participant.muted
          participantType = participant.type
        }
      })
    }
    const AlwaysScrollToBottom = () => {
      const elementRef = useRef();
      useEffect(() => { 
        if (props.class.props.class.props.autoScroll)
        {
          elementRef.current.scrollIntoView()
        }
      });
      return <div ref={elementRef} />;
    }

    const chatAreaScroll = e  => {
      const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight - 10 & e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;
      if (bottom) {
        props.class.props.class.props.setAutoScroll(true)
      } else {
        props.class.props.class.props.setAutoScroll(false)
      }
    }

    var address = [];
    if (recipient.type == "influencer" && recipient.address != {}){
        ["address1","address2","city","region","postcode"].forEach(line => {
        if (recipient.address[line] && recipient.address[line].length > 0){
          address.push(recipient.address[line])
        }
      })
    }

    return (
      <div className={`chatBox shadow-sm rounded-end h-100 ${!props.chatBox ? "hide": ""}`}>
        <div className="px-3 chatHeader">
          <div className="py-2 mb-2 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center text-truncate">
              <a className="mobileView pe-3" onClick={()=>props.setChatBox(false)}><img src={backArrow} /></a>
              <div className="pe-3">
                <img src={getImageUrl(props.class.props.providers,recipient.profileImage)} width="46px" height="46px" className="object-fit-cover rounded border bg-background" alt={recipient.name} />
              </div>
              <div className="text-truncate pe-4">
                <h6 className="mb-0 mw-100 text-truncate">{recipient.name}</h6>
                {!props.bulkMessage.visible && props.bidDetails && (
                  <Link className="text-blue small" to={"/Campaign/Preview?id="+props.bidDetails.campaignID} ><img className="mb-1 me-1" src={rightArrow} /> {props.bidDetails.title}</Link>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center">

              { recipient.type == "influencer" && (
                <OverlayTrigger trigger="click" placement="bottom"
                    overlay={
                      <Popover>
                        <Popover.Header as="h3">Contact Details</Popover.Header>
                        <Popover.Body>
                          <div className="small">
                            <span className="text-muted">Address:</span>
                            <div className="mb-2">{address.join(", ")}</div>
                            {recipient.hasOwnProperty("phoneNumber") && recipient.phoneNumber && (
                              <>
                              <span className="text-muted">Phone Number:</span>
                              <div className="mb-2">{recipient.phoneNumber}</div>
                              </>
                            )}
                            {recipient.hasOwnProperty("email") && recipient.email && (
                              <>
                              <span className="text-muted">Email:</span>
                              <div className="mb-2">{recipient.email}</div>
                              </>
                            )}
                          </div>
                        </Popover.Body>
                      </Popover>
                    }>                                  
                    <img className="cursor-pointer" src={blueProfileCard} height="18px" />
                </OverlayTrigger>
              ) }
              
              <DropdownButton drop="start" variant="light" className="moreVertical ms-3" title="" >
                {props.unreadMessages == 0 ? <Dropdown.Item className="small" onClick={() => props.class.markConversationAsUnread(props.id)}>Mark as Unread</Dropdown.Item> : <Dropdown.Item className="small" onClick={() => props.class.markConversationAsRead(props.id)}>Mark as Read</Dropdown.Item>}
                {muted ? <Dropdown.Item className="small" onClick={() => props.class.unmuteConversation(props.id)}>Unmute Notifications</Dropdown.Item> : <Dropdown.Item className="small" onClick={() => props.class.muteConversation(props.id)}>Mute Notifications</Dropdown.Item>}
                {/* <Dropdown.Divider />
                <Dropdown.Item className="small text-danger">Report & Block</Dropdown.Item> */}
              </DropdownButton>
            </div>
          </div>
        </div>

        <div className="chatBody">
          <div className="chatArea" onScroll={chatAreaScroll}>
            <div className="text-center text-muted py-3 small">{props.bulkMessage.visible ? "Write your bulk message here" : `This is the start of your conversation with ${recipient.name}`}</div>
            {props.bulkMessage.visible ? (
              <></>
            )
            : (
              <>
              {[...props.messages].reverse().map(message => (
                <span key={message._id}>
                  {message.messageType == "update" ? (
                    <div className="text-center text-muted py-3 small">
                      {message.contents}
                      <span className="smaller ps-2">({relativeTimeFormat(message.messageTime*1000)})</span>
                    </div>
                  ) :
                  (
                  <>
                  {/* <div className="mb-4 text-center border-bottom h-15px">
                    <span className="fw-normal border text-muted smaller badge text-dark bg-gray">{isToday(new Date(message.messageTime*1000)) ? "Today" : (new Date(message.messageTime*1000)).toLocaleDateString('en-GB', { weekday:"long", year:"numeric", month:"short", day:"numeric"})}</span>
                  </div> */}
                  <div className={message.sender != me._id ? "bubbleLeft" : "bubbleRight"}>
                    <div className={message.sender != me._id ? "bubbleLeftBoxes" : "bubbleRightBoxes"}>
                      <div className={message.sender != me._id ? "bubbleLeftText" : "bubbleRightText"}>
                        {message.messageType == "image" && <div className="imagesBoxView h-auto me-1 cursor-pointer"><img src={getImageUrl(props.class.props.providers,message.contents,["w_250","c_scale"])} className="object-fit-cover rounded-xl mt-2 me-2 mb-2 w-100" height="100px" alt={`Image from ${recipient.name}`} onClick={() => {props.class.props.class.props.setShowCarousel({visible:true,image:message.contents})}} aria-controls="imageViewer" /></div>}
                        {message.messageType == "file" && <div><a href={getFileUrl(props.class.props.providers,message.contents)} download={message.contents.name}><img src={Document} height="60px" className="object-fit-contain rounded" alt={`Document from ${recipient.name}`} /></a>{message.contents.name}</div>}
                        {message.messageType == "video" && <div><a href={getVideoURL(props.class.props.providers,message.contents)}><img src={Video} height="60px" className="object-fit-contain rounded" alt={`Document from ${recipient.name}`} /></a></div>}
                        {(message.messageType == "text" || message.messageType == "whatsapp") && formatText(message.contents)}
                        {(message.messageType == "whatsappTemplate") && formatText(`<b>Template Sent</b><br>${message.contents}`)}
                        <div className={message.sender != me._id ? "smaller text-muted text-nowrap pt-1" : "smaller text-nowrap pt-1" }>
                        {message.messageType == "whatsapp" && <img src={whatsapp} className="ms-1 WhatsappIndicator" />} {relativeTimeFormat(message.messageTime*1000)} <img className="ms-1" src={message.sender != me._id ? grayDoubleChecks : whiteDoubleChecks }/>
                        </div>
                      </div>
                    </div>
                  </div>
                  </>
                  )}
                  <AlwaysScrollToBottom />
                </span>
                )
              )} 
              </>         
            )}
          </div>
        </div>

        {props.class.props.class.props.showCarousel.visible && (
          <Fade in={props.class.props.class.props.showCarousel.visible}>
            <div id="imageViewer">
              <div className="carouselControl">
                <a href={getImageUrl(props.class.props.providers, props.class.props.class.props.showCarousel.image,null,true)} download target="_blank" className="btn btn-sm btn-success">Download</a>
                <button type="button" onClick={() => props.class.props.class.props.setShowCarousel({visible:false,image:null})} className="btn btn-sm btn-light closeImageViewer">Close</button>
              </div>
              <Carousel>
                <Carousel.Item>
                  <img id="0" className="d-block rounded-xl" src={getImageUrl(props.class.props.providers, props.class.props.class.props.showCarousel.image,["w_500","c_scale"])} alt={props.class.props.class.props.showCarousel.image.name} />
                </Carousel.Item>
              </Carousel>
            </div>
          </Fade> 
        )}  

        <div className="chatFooter border-top">
          <div className="position-relative d-flex justify-content-center">
          {props.bulkMessage.visible ? (
            <Alert variant="light" className="d-flex align-items-center justify-content-between border-gray px-3 p-2 alertBar shadow-sm border">
              <div className="smaller">This message will be sent to all the recipients selected</div>
          </Alert>
           ) : (
           <>
            {props.bidDetails.state == "Pending" && (
              <Alert variant="light" className="d-flex align-items-center justify-content-between border-gray px-3 p-2 alertBar shadow-sm border">
                {participantType == "influencer" ? ( 
                <>
                  <div className="smaller">Your bid is still pending approval from <strong>{recipient.name}</strong>, so you won't be able to send any more messages to them at this moment.</div>
                </>
                ) : (
                  <>
                    <div className="smaller">This bid from <strong>{recipient.name}</strong> is still pending, don't forget to approve/decline their bid!</div>
                    <a onClick={() => props.setTabID("bids")} className="text-primary ms-3 fw-500 small text-nowrap">Review bids</a>
                  </>
                )  
              }
              </Alert>
            )}
            </>
          )}
          </div>
          {props.bulkMessage.visible ? <SendMessageForm recipient={recipient} conversations={props.bulkMessage.recipients.map(recipient => recipient.conversationID)} sender={me.id} isBulkMessage={true}/> : <SendMessageForm recipient={recipient} conversationID={props.id} sender={me._id} showConversation={props.showConversation} unblockChat={unblockChat} whatsappEnabled={props.class.props.class.props.session.sessionType == "impersonation" || props.class.props.class.props.session.currentProfile.profile.features.includes("all","whatsapp")} />}
        </div>
      </div>
    );}

  ContextMenu(props){
    return (
      <div className="rightClickFilter" onClick={() => props.handleClose()}>
        <ul>
          <li onClick={() => props.performBulkMessage("pending",props.class)}>{(getStatusPill("Pending"))}</li>
          <li onClick={() => props.performBulkMessage("accepted",props.class)}>{(getStatusPill("Accepted"))}</li>
          <li onClick={() => props.performBulkMessage("in progress",props.class)}>{(getStatusPill("In Progress"))}</li>
          <li onClick={() => props.performBulkMessage("marked as complete",props.class)}>{(getStatusPill("Marked as Complete"))}</li>
          <li onClick={() => props.performBulkMessage("completed",props.class)}>{(getStatusPill("Completed"))}</li>
        </ul>
      </div>
    )
  }

  handleContextMenu(e){
    e.preventDefault();
    const { xCord, yCord } = e
    this.props.class.props.setContextMenu({visible : true, x : xCord, y : yCord})
  }

  performBulkMessage(selection,classRef){
    var recipients = [];
    classRef.props.class.props.conversations.conversations.filter(function(conversation) { return conversation.bidDetails.state.toLowerCase() == selection }).forEach(conversation =>{
      var recipient = null;
      conversation.participants.forEach(function (participant) {
        if (!participant.hasOwnProperty("me")){
          recipient = participant.details
        }
      })
      recipients.push({"recipient":recipient,"conversationID":conversation._id}) 
      })
    classRef.props.class.props.setBulkMessage({"visible":true,"recipients":recipients});
    classRef.props.class.props.setTabID("messages")
    classRef.props.class.props.setUpdateCounter(classRef.props.class.props.updateCounter + 1)
  }

  handleFilterUpdate(value,type) {
    var filters = structuredClone(this.props.class.props.inboxFilters);
    if (type == "search") {
      filters.search = value.target.value.toLowerCase();
    }
    else if (type === "bidType") {
      filters.unread = false
      filters.archived = false
      delete filters["deliveryState"]

      if (value === "All") {
        delete filters["bidType"]
      }
      else if (value === "Unread") {
        filters.unread = true
      }
      else if (value === "Archived") {
        filters.archived = true
      }
      else if (["unsent","sent","received"].includes(value)) {
        filters.deliveryState = value
      }
      else {
        filters.bidType = value
        filters.unread = false
        filters.archived = false
      }
    }
    this.props.class.props.setInboxFilters(filters)
    setFilter(filters,"conversation")
    this.getConversations(this.props.campaignID)
  }

  render() {
    const { error, isLoaded, isConversationLoaded, filter } = this.state;
    if (error) {
      return <div className="text-danger text-center h-100 d-flex align-items-center justify-content-start px-4 px-md-0 py-5 flex-column fs-5 bg-secondary"><img src={NoAccess} className="noAccessImg my-5 rounded-xl shadow" /><div>Error: {error}</div></div>;
    } else if (!isLoaded) {
      return <FullPageSpinner />;
    } else {
    return (
      <Row className="mx-0 px-md-3 justify-content-center messagesPage">
        {/* <this.BulkMessageModal brandID={this.props.class.props.currentProfile.profile.id} class={this.props.class} /> */}
        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 senderList shadow-sm rounded-start px-0 ps-md-3">
          <div className="inboxSearch pt-3 pt-md-0">
            <InputGroup className="py-1 position-relative">
              {/* <InputGroup.Text className="bg-background">
                <img src={Search} />
              </InputGroup.Text> */}
              {this.props.class.props.contextMenu.visible && <this.ContextMenu x={this.props.class.props.contextMenu.x} y={this.props.class.props.contextMenu.y} handleClose={() => this.props.class.props.setContextMenu({visible:false,x:0,y:0})} performBulkMessage={this.performBulkMessage} class={this} />}
              <Form.Control placeholder="Search" className="border-end-0" defaultValue={filter.search} onChange={e => { this.setState({ filter: { search: e.target.value.toLowerCase() }}); this.props.class.props.setFilterUnreadMessages(false); }} />
              <Button variant="default" size="sm" className="border border-start-0 border-end-0" onClick={() => {this.props.class.props.setViewMarkAllAsReadModal(true)}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-open" viewBox="0 0 16 16">
                  <path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882zM15 7.383l-4.778 2.867L15 13.117zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765z"/>
                  <title>Select to mark all conversations as read</title>
                </svg>
              </Button>
              {this.props.class.props.viewMarkAllAsReadModal &&
                <Modal centered show>
                  <Modal.Header className="bg-primary text-background">
                    <Modal.Title className="h6">Mark all conversations as read</Modal.Title>
                  </Modal.Header>
                  <Form>
                    <Modal.Body className="pt-0">
                      <div className="pt-3">
                        <p className="fw-bold mb-2">Are you sure you want to mark all conversations as read?</p>
                      </div>
                    </Modal.Body>
                    <Modal.Footer className="p-3 pt-0 border-0">
                      <Button variant="outline-secondary" size="sm" className="m-0 me-2" onClick={() => {this.props.class.props.setViewMarkAllAsReadModal(false)}}>
                        Cancel
                      </Button>
                      <Button variant="success" size="sm" className="m-0" type="submit" onClick={(e) => {e.preventDefault();this.markAllConversationsAsRead()}}>
                        Mark as read
                      </Button>
                    </Modal.Footer>
                  </Form>
                </Modal>
              }
              <Button variant="default" size="sm" className="border border-start-0 border-end-0">
                <img title={this.props.class.props.bulkMessage.visible ? "Send bulk message" : "Select recipients to send bulk message"} src={this.props.class.props.bulkMessage.visible ? groupClicked : group} onClick={() => {this.toggleBulkMessaging()}} onContextMenu={(e) => this.handleContextMenu(e)} />
              </Button>
              <Dropdown onSelect={e => { this.handleFilterUpdate(e,"bidType") }}>
                  <Dropdown.Toggle variant="white" className="messageFilterBtn border border-start-0">
                    <img src={messageFilter} height="18px" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow">
                    <Dropdown.Item eventKey={"All"} active={!this.props.class.props.inboxFilters.bidType}>All</Dropdown.Item>
                    <Dropdown.Item eventKey={"Accepted"} active={this.props.class.props.inboxFilters.bidType === "Accepted"}>Accepted</Dropdown.Item>
                    <Dropdown.Item eventKey={"Pending"} active={this.props.class.props.inboxFilters.bidType === "Pending"}>Pending</Dropdown.Item>
                    <Dropdown.Item eventKey={"In Progress"} active={this.props.class.props.inboxFilters.bidType === "In Progress"}>In Progress</Dropdown.Item>
                    <Dropdown.Item eventKey={"Marked as Complete"} active={this.props.class.props.inboxFilters.bidType === "Marked as Complete"}>Marked as Complete</Dropdown.Item>
                    <Dropdown.Item eventKey={"Completed"} active={this.props.class.props.inboxFilters.bidType === "Completed"}>Completed</Dropdown.Item>
                    <Dropdown.Item eventKey={"Rejected"} active={this.props.class.props.inboxFilters.bidType === "Rejected"}>Declined</Dropdown.Item>
                    <Dropdown.Item eventKey={"Cancelled"} active={this.props.class.props.inboxFilters.bidType === "Cancelled"}>Cancelled</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey={"Unread"} active={this.props.class.props.inboxFilters.unread}>Unread</Dropdown.Item>
                    <Dropdown.Item eventKey={"Archived"} active={this.props.class.props.inboxFilters.archived}>Archived</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
            </InputGroup>
          </div>
        {this.props.class.props.conversations.conversations.filter(function(conversation) { var valid=false; conversation.participants.forEach(function (participant) {
          if (!participant.hasOwnProperty("me")){
            if (participant.details.name.toLowerCase().includes(filter.search)) {
              valid = true;
            }
          } }) ; if (valid) { return conversation }  }).map(conversation => <this.ConversationListItem key={conversation._id} id={conversation._id} participants={conversation.participants} lastMessage={conversation.lastMessage} setChatBox={this.props.setChatBox} chatBox={this.props.chatBox} bidDetails={conversation.bidDetails} selectedConversation={this.props.class.props.conversationID} unreadMessages={conversation.unreadMessages} class={this} bulkMessage={this.props.class.props.bulkMessage} />)
        }
        </div>
        {this.props.class.props.conversations.conversations.length > 0 ? (
          <>
          {isConversationLoaded ? (
          <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 px-0 conversationDetail">
            <this.ConversationDetailItem key={this.props.class.props.conversations.conversation._id} messages={this.props.class.props.conversations.messages} id={this.props.class.props.conversations.conversation._id} participants={this.props.class.props.conversations.conversation.participants} setChatBox={this.props.setChatBox} chatBox={this.props.chatBox} bidDetails={this.props.class.props.conversations.conversation.bidDetails} showConversation={this.showConversation} unreadMessages={this.props.class.props.conversations.conversation.unreadMessages} setTabID={this.props.setTabID} class={this} bulkMessage={this.props.class.props.bulkMessage} />
          </div>
          ) :
          (
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 px-0 conversationDetail">
              <InboxLoader key={"empty"}/>
            </div>
          )
                          }
          </>
        ) : 
        <div className="col-12 col-sm-12 col-md-8 col-lg-8 px-0">
        </div>}
      </Row>
    )}
  }
}

class CampaignManageView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      open: false,
      selectedBid: null,
      conversationLoaded: false
    };
    this.getCampaign(props.id)
    this.getConversation = this.getConversation.bind(this);
    if (getFilter("campaign")) {
      this.props.setFilters(JSON.parse(getFilter("campaign")))
    }
    let query = new URLSearchParams(window.location.search);
    if (query.get("orderBy")) {
      this.props.setOrderBy(query.get("orderBy"))
    }
    if (query.get("sortBy")) {
      this.props.setSortBy(query.get("sortBy"))
    }
    if (query.get("bidFilter")) {
      var bidFilter = JSON.parse(query.get("bidFilter"))
      var tempFilters = this.props.filters;
      for (const [key,value] of Object.entries(tempFilters)){
        if (bidFilter.hasOwnProperty(key)){
          tempFilters[key] = bidFilter[key]
        }
      }
      this.props.setShowFilter("moreAdvanced")
      this.props.setFilters(tempFilters);
    }
  }

  async getCampaign(id) {
    var response = await apiCall(`myCampaign?id=${id}`,{ "method" : "GET" });
    if (response["success"]) {
      this.setState({
        campaign : response["success"]["campaign"]
      });
      this.props.setFilteredCollaborators(response["success"]["campaign"]["collaborators"])
      var bids = await this.getBids()
      await this.getSavedFilters(this.props)
      this.props.setUnreadMessages(response["success"]["campaign"]["unreadMessages"])
      var cities = [];
      response["success"]["campaign"]["pendingBids"].forEach(bid => {
        cities.push(bid.profile.address.city)
      })
      var genders = [];
      response["success"]["campaign"]["pendingBids"].forEach(bid => {
        genders.push(bid.profile.gender)
      })
      var interests = [];
      response["success"]["campaign"]["pendingBids"].forEach(bid => {
        bid.profile.interests.forEach(interest => {
          interests.push(interest)
        })
      })
      this.props.filters.availableCities = [...new Set(cities)];
      this.props.filters.availableGenders = [...new Set(genders)];
      this.props.filters.availableInterests = [...new Set(interests)];
      this.props.setSubscription(response["success"]["subscription"])
      this.props.setMaxAcceptedBids(response["success"]["brand"]["maxAcceptedBids"])
      this.doSorting(this.props.sortBy,this.props.orderBy,bids)
    }
    else {
      this.setState({
        isLoaded: true,
        error: response["failure"]["error"]
    });
    }
    this.setState({
      isLoaded: true
    })
  }

  async getBids(){
    let urlParams = new URLSearchParams(window.location.search);
    var response = await apiCall(`campaign/bids?${urlParams.toString()}`,{ "method" : "GET" });
    if (response["success"]) {
      this.props.setBids(response["success"]["bids"])
      this.props.setAcceptedBids(response["success"]["collaborators"])
      this.props.setRejectedBids(response["success"]["rejectedBids"])
      this.props.setCancelledBids(response["success"]["cancelledBids"])

    }
    return response["success"]["bids"]
  }

  // helper to get visible bids
  getVisibleBids = (param = {}) => {
    const { bidsTab, bids } = this.props;
    let filtered = bids;
    if (bidsTab === "recommended") {
      filtered = bids.filter(bid => bid.details.recommended === true);
    } else if (bidsTab === "favourites") {
      filtered = bids.filter(bid => bid.details.favourite === true);
    } else if (bidsTab === "pending") {
      filtered = bids;
    }
    if (param.recommended) {
      filtered = filtered.filter(bid => bid.details.recommended === true);
    }
    if (param.favourite) {
      filtered = filtered.filter(bid => bid.details.favourite === true);
    }
    return filtered;
  }

  async getReport(type) {
    if (type == "collaborator"){
      await apiCall(`myCampaign/collaboratorData?id=${this.props.id}`,{ "method" : "GET", "isFile":true });
    }
    else if (type == "bidder"){
      await apiCall(`myCampaign/bidData?id=${this.props.id}`,{ "method" : "GET", "isFile":true });
    }
    else if (type == "favourites"){
      await apiCall(`myCampaign/bidData?id=${this.props.id}&favourites=true`,{ "method" : "GET", "isFile":true });
    }
    else if (type == "recommended"){
      await apiCall(`myCampaign/bidData?id=${this.props.id}&recommended=true`,{ "method" : "GET", "isFile":true });
    }
    else if (type == "favourites&recommended"){
      await apiCall(`myCampaign/bidData?id=${this.props.id}&favourites=true&recommended=true`,{ "method" : "GET", "isFile":true });
    }
  }

  async getConversation(id) {
    var conversationDict = this.props.conversationModal;
    var response = await apiCall(`conversation?id=${id}&limit=5`,{ "method" : "GET" });
    if (response["success"]) {
        conversationDict["conversation"] = response["success"]["conversation"];
        conversationDict["messages"] = response["success"]["messages"];
        this.setState({conversationLoaded: true})
    }
    else {
      this.setState({
        error: response["failure"]["error"]
    });
    }
    this.props.setConversationModal(conversationDict);
  }

  onOpenBidderModal = bidder => {
    this.setState({
      open: true,
      selectedBid: bidder
    });
  };

  onCloseBidderModal = () => {
    this.setState({ open: false });
  };

  updateSelectedBids = (bid) => {
    var bids = this.props.selectBids;
    if (bids.hasOwnProperty(bid.details.id)) {
      bids = Object.fromEntries(Object.entries(bids).filter(([key]) => key != bid.details.id)); //If we don't add this, state doesn't update :) 
    }
    else {
      bids[bid.details.id] = bid
      bids = Object.fromEntries(Object.entries(bids).filter(([key]) => key != null)); //If we don't add this, state doesn't update :) 
    }
    this.props.setSelectBids(bids);
    if (this.state.campaign.pendingBids.length > Object.keys(bids).length){
      this.props.setSelectAllBids(false);
    }
    else{
      this.props.setSelectAllBids(true);
    }
    this.props.setSelectRecommendedBids(false)
  }

  handleSelectAllBids = e => {
    this.props.setSelectAllBids(!this.props.selectAllBids)
    let bids = {};
    if (!this.props.selectAllBids) {
      this.getVisibleBids().forEach(bid => {
        bids[bid.details.id] = bid;
      });
      this.props.setSelectRecommendedBids(false);
    } else {
      bids = {};
      this.props.setSelectRecommendedBids(false);
    }
    this.props.setSelectBids(bids);
  }

  handleSelectRecommendedBids = e => {
    this.props.setSelectRecommendedBids(!this.props.selectRecommendedBids)
    this.props.setSelectAllBids(false);
    let bids = {};
    if (!this.props.selectRecommendedBids) {
      this.getVisibleBids({ recommended: true }).forEach(bid => {
        bids[bid.details.id] = bid;
      });
    }
    this.props.setSelectBids(bids);
  }

  doSorting(sortBy,orderBy,bidData=null){
    var bids = null;
    if (bidData == null){
      bids = this.props.bids;
    }
    else {
      var bids = bidData;
    }
    var bids = bids.sort((a,b) => {
      var opA = null; var opB = null;
      switch(sortBy){
        case "createdAt":
          opA = a.details.time
          opB = b.details.time
          break
        case "age":
          opA = getAge(a.profile.dob)
          opB = getAge(b.profile.dob)
          break
      }

      switch(orderBy){
        case "ascending":
          return opA - opB
        case "descending":
          return opB - opA
      }
      
    })
    this.props.setBids(bids);
  }

  handleSortBy = e => {
    this.props.setSortBy(e.target.value)
    let currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set('sortBy', e.target.value);
    let newUrl = window.location.origin + window.location.pathname + '?' + currentUrlParams.toString();
    window.history.replaceState({path:newUrl},'',newUrl);
    this.doSorting(e.target.value,this.props.orderBy)
  }

  handleOrderBy = e => {
    this.props.setOrderBy(e.target.value);
    let currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set('orderBy', e.target.value);
    let newUrl = window.location.origin + window.location.pathname + '?' + currentUrlParams.toString();
    window.history.replaceState({path:newUrl},'',newUrl);
    this.doSorting(this.props.sortBy,e.target.value);
  }

  async doFiltering(){
  var newBids = await this.getBids();
  this.props.setBids(newBids);
  this.doSorting(this.props.sortBy, this.props.orderBy, newBids);
}


  async handleFilterUpdate(props,type,delay=500) {
    var filters = this.props.filters;
    if (["cities","genders","interests","segments","primaryInterests","previouslyAccepted"].includes(type)){
      filters[type] = [];
      props.forEach(item => {
        filters[type].push(item.value);
      })
    }

    else if (["ages","audienceFollowing"].includes(type)) {
      filters[type][props.target.id] = props.target.value;
    }
    else if (type == "fee") {
      const field = props.target.id;
      const v = props.target.value;
      // Convert to number or null
      if (v === "") {
        filters[type][field] = null;
      } else {
        const parsed = parseInt(v, 10);
        filters[type][field] = isNaN(parsed) ? null : Math.max(0, parsed);
      }
      
      // Don't return early - let it fall through to the normal filtering logic below
    }
    else if (type == "search") {
      filters.search = props.target.value.toLowerCase();
    }
    else if (type == "collaborationsSearch") {
      filters.collaborationsSearch = props.target.value.toLowerCase();
    }
    else if (type == "previousBidders") {
      filters.previousBidderOnly = props.target.checked
    }


    else if (type == "muted") {
      filters.muted = props.target.checked
    }
    else if (type == "favourite") {
      filters.favourite = props.target.checked
    }
    else {
      filters[type] = parseInt(props.target.value);
    }
    this.props.setFilters(filters);
    setFilter(filters,"bid",["availableCities","availableGenders","availableInterests"])
    if (delay) {
      if (this.props.filterTimer) {
        clearTimeout(this.props.filterTimer)
      }
      this.props.setFilterTimer(setTimeout(() => this.doFiltering(), delay))
    } else {
      this.doFiltering()
    }
  }

  

  async getSavedFilters(props,filterName=null){
    if (filterName){
      var response = await apiCall(`brand/filters?id=${props.currentProfile.profile.id}&filterName=${filterName}`,{ "method" : "GET" });
      if (response["success"]) {
        var returnedFilters = response["success"]["filters"]
        if (returnedFilters.length > 0){
          returnedFilters = returnedFilters[0]
        }
        var tempSavedFilters = structuredClone(props.savedFilters)
        var found = false
        tempSavedFilters.filters.forEach(filter => {
          if (filter.name == returnedFilters.name){
            found = true
            filter.filters = returnedFilters.filters
          }
        })
        if (found == false){
          tempSavedFilters.filters.push(returnedFilters)
        }
        props.setSavedFilters(tempSavedFilters)
        return tempSavedFilters
      }
      else {
        props.setAlert({"display":"toast","visible":true,"title":"Could Not Load Filter","content":response["failure"]["error"],"className":"bg-danger text-background"})
      }; 
    }
    else {
      var response = await apiCall(`brand/filters?id=${props.currentProfile.profile.id}`,{ "method" : "GET" });
      if (response["success"]) {
        var tempSavedFilters = structuredClone(props.savedFilters)
        tempSavedFilters.filters = response["success"]["filters"]
        props.setSavedFilters(tempSavedFilters)
        return tempSavedFilters
      }
      else {
        props.setAlert({"display":"toast","visible":true,"title":"Could Not Load Filters","content":response["failure"]["error"],"className":"bg-danger text-background"})
      };
    }
  }

  SavedFiltersModal(props){
    var options = generateDropdown(props.class.props.savedFilters.filters.map(filter => {return filter.name}))
    const handleSubmit = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)
      if (props.class.props.savedFilters.selected){
        var response = await apiCall(`brand/filters?id=${props.class.props.currentProfile.profile.id}`,{ "method" : "PUT", "data" : {"name":props.class.props.savedFilters.selected,"filters":props.class.props.filters} });
        if (response["success"]) {
          var tempSavedFilters = structuredClone(props.class.props.savedFilters)
          tempSavedFilters.filters.forEach(filter => {
            if (filter.name == props.class.props.savedFilters.selected){
              filter.filters = props.class.props.filters
            }
          })
          props.class.props.setSavedFilters(tempSavedFilters)
          props.class.props.setAlert({"display":"toast","visible":true,"title":"Filter Updated","content":"Filter was updated successfully","className":"bg-success text-background"})
        }
        else {
          props.class.props.setAlert({"display":"toast","visible":true,"title":"Could Not Update Filter","content":response["failure"]["error"],"className":"bg-danger text-background"})
        };
      }
      props.class.props.setIsSubmitting(false)
    }
    const handleDelete = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)
      if (props.class.props.savedFilters.selected){
        var response = await apiCall(`brand/filters?id=${props.class.props.currentProfile.profile.id}&filterName=${props.class.props.savedFilters.selected}`,{ "method" : "DELETE" });
        if (response["success"]) {
          var tempSavedFilters = structuredClone(props.class.props.savedFilters)
          tempSavedFilters.filters = tempSavedFilters.filters.filter(function(filter) { return filter.name != props.class.props.savedFilters.selected })
          props.class.props.setSavedFilters(tempSavedFilters)
          options = generateDropdown(tempSavedFilters.filters.map(filter => {return filter.name}))
          updateSavedFilters(null,tempSavedFilters)
          props.class.props.setAlert({"display":"toast","visible":true,"title":"Filter Deleted","content":"Filter was deleted successfully","className":"bg-success text-background"})
        }
        else {
          props.class.props.setAlert({"display":"toast","visible":true,"title":"Could Not Delete Filter","content":response["failure"]["error"],"className":"bg-danger text-background"})
        };
      }
      props.class.props.setIsSubmitting(false)
    }
    const createNewFilter = async filterName => {
      props.class.props.setIsSubmitting(true)
      var response = await apiCall(`brand/filters?id=${props.class.props.currentProfile.profile.id}`,{ "method" : "PUT", "data" : {"name":filterName,"filters":props.class.props.filters} });
      if (response["success"]) {
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Filter Created","content":"Filter was created successfully","className":"bg-success text-background"})
        var newFilters = await props.class.getSavedFilters(props.class.props,filterName)
        options = generateDropdown(newFilters.filters.map(filter => {return filter.name}))
        updateSavedFilters(filterName,newFilters)
      }
      else {
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Could Not Create Filter","content":response["failure"]["error"],"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    const updateSavedFilters = (filterName,filters=null) => {
      var tempSavedFilters = structuredClone(props.class.props.savedFilters)
      if (filters){
        tempSavedFilters = filters
      }
      tempSavedFilters.selected = filterName
      if (filterName){
        tempSavedFilters.filters.forEach(filter => {
          if (filter.name == filterName){
            props.class.props.setFilters(filter.filters);
            setFilter(filter.filters,"bid",["availableCities","availableGenders","availableInterests"])
            if (props.class.props.filterTimer) {
              clearTimeout(props.class.filterTimer)
            }
            props.class.props.setFilterTimer(setTimeout(() => props.class.doFiltering(), 250))
          }
        })
      }
      else {
        var resetFilters = {"cities":[],"availableCities":[],"genders":[],"availableGenders":[],"ages":[], "fee": { minFee: "", maxFee: "" },"previousBidderOnly":false,"search":"","interests":[],"availableInterests":[],"collaborationsSearch" : "","segments":[],"muted":false,"favourite":false,"previouslyAccepted":[],"primaryInterests":[]}
        props.class.props.setFilters(resetFilters);
        setFilter(resetFilters,"bid",["availableCities","availableGenders","availableInterests"])
        if (props.class.props.filterTimer) {
          clearTimeout(props.class.filterTimer)
        }
        props.class.props.setFilterTimer(setTimeout(() => props.class.doFiltering(), 250))
      }
      props.class.props.setSavedFilters(tempSavedFilters)
    }
    const handleClose = e => {
      var tempSavedFilters = structuredClone(props.class.props.savedFilters)
      tempSavedFilters.visible = false
      props.class.props.setSavedFilters(tempSavedFilters)
    }
    options.unshift({"label":"None","value":null})
    if (props.class.props.savedFilters.visible){
      return (
        <Modal centered show onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="h6">Saved Listing Filters</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body className="pt-0">
              <div className="pt-3">
                <p className="small text-muted">
                  Select an existing filter to load the parameters saved previously.<br /> 
                  If you want to update the filter, select it, make your changes and click "Update Selected Filter".<br /> 
                  If you want to create a filter, click on the dropdown and type your new filter name and click on "Create".
                </p>
                <div className="form-group mb-3">
                  <label>Select a Saved Filter</label>
                  <div className="small text-muted">
                    <CreatableSelect
                      closeMenuOnSelect={true}
                      components={props.class.props.animatedComponents}
                      defaultValue={[]}
                      disabled={props.class.props.isSubmitting}
                      value={options.filter(function(selection) { return props.class.props.savedFilters.selected == selection.value })}
                      options={options} 
                      id="savedFilters" 
                      onChange={ (choice) => updateSavedFilters(choice.value) } 
                      onCreateOption={ (choice) => createNewFilter(choice) }
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="p-3 pt-0 border-0">
              <Button variant="outline-secondary" size="sm" className="m-0 me-2" onClick={handleClose}>
                Close
              </Button>
              <Button variant="danger" size="sm" className="m-0 me-2" disabled={props.class.props.isSubmitting || !props.class.props.savedFilters.selected}  type="submit" onClick={handleDelete}>
                {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Deleting...</> : "Delete Selected Filter"}
              </Button>
              <Button variant="success" size="sm" className="m-0" disabled={props.class.props.isSubmitting || !props.class.props.savedFilters.selected || props.class.props.savedFilters.filters.filter(function(filter) { return filter.filters == props.class.props.filters && filter.name == props.class.props.savedFilters.selected }).length > 0}  type="submit" onClick={handleSubmit}>
                {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...</> : "Update Selected Filter"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )
    }
    else {
      return (<></>)
    }
  }

  ApprovalModal(props){
    var error = null;
    const handleSubmit = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)

  var response = await apiCall(`campaign/bid/accept?id=${props.class.props.id}`,{ "method" : "PUT", "data" : {"bids":Object.keys(bids),"message":props.reason} });
      if (response["success"]) {
        props.class.getCampaign(props.class.props.id)
        props.class.props.setSelectBids({});
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Bids Accepted","content":"All bids were accepted successfully","className":"bg-success text-background"})
        props.handleClose()
      }
      else {
        error = response["failure"]["error"]
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Error Accepting Bids","content":error,"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    const bids = props.class.props.selectBids;
    var bid = {};
    if (Object.keys(bids).length > 0){
      if (Object.keys(bids).length == 1){
        var bid = bids[Object.keys(bids)[0]]
      }
      return (
        <Modal centered show={props.show} onHide={props.handleClose}>
          <Modal.Header className="bg-success text-background" closeButton>
            <Modal.Title className="h6">Are you sure you want to accept {Object.keys(bids).length == 1 ? bid.profile.name : Object.keys(bids).length + " bids"}?</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body className="pt-0">
              <Row className="selectedBids">
                {Object.keys(bids).length > 1 && Object.entries(bids).map((bidder, index) => (
                  <div className="col-6 d-flex align-items-center small pt-3" key={bidder[0]}>
                    <img src={getImageUrl(props.class.props.providers,bidder[1].profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" width="42px" className="border rounded me-2" />
                    <span>{bidder[1].profile.name}</span>
                  </div>
                ))}
              </Row>
                <Form.Group className="form-group">
                  <Form.Label>Enter a message to send to {Object.keys(bids).length == 1 ? bid.profile.name : "all selected bids"}:</Form.Label>
                  <Form.Control 
                  onChange={e => props.setReason(e.target.value)}
                  value={props.reason}
                  as="textarea"
                  id="message"
                  placeholder="Write your message here..."
                  rows={5}
                  />
                  {Object.keys(bids).length > 1 && <p className="small mt-2 mb-0">Please note that the date selected and message written will be sent to all selected bidders.</p>}
                </Form.Group>

            </Modal.Body>
            <Modal.Footer className="p-3 pt-0 border-0">
              <Button variant="outline-secondary" size="sm" className="m-0 me-2" onClick={props.handleClose}>
                Cancel
              </Button>
              <Button variant="success" size="sm" className="m-0" disabled={props.class.props.isSubmitting}  type="submit" onClick={handleSubmit}>
                {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Accepting...</> : "Accept Bids"}
              </Button>
              {error && <div className="error text-danger small ms-3">{error}</div>}
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    else{
      return (<></>)
    }
  }

  CancelModal(props){
    var error = null;
    const handleClose = e => {
      props.class.props.setCancelModal({"visible":false,"collaborator":null,"rejecting":false})
    }
    const handleSubmit = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)

      var response = await apiCall(`campaign/bid/cancel?id=${props.class.props.id}`,{ "method" : "PUT", "data" : {"bid":props.class.props.showCancelModal.collaborator.details.id,"message":props.reason,"rejecting":props.class.props.showCancelModal.rejecting} });
      if (response["success"]) {
        props.class.getCampaign(props.class.props.id)
        props.class.props.setSelectBids({});
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Collaboration Cancelled","content":"The collaboration was cancelled successfully","className":"bg-success text-background"})
        handleClose()
      }
      else {
        error = response["failure"]["error"]
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Error Cancelling Collaboration","content":error,"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    if (props.class.props.showCancelModal.visible){
      if (props.class.props.showCancelModal.rejecting) {
        return (
          <Modal centered show={props.show} onHide={handleClose}>
            <Modal.Header className="" closeButton>
              <Modal.Title className="h6">You are rejecting {props.class.props.showCancelModal.collaborator.profile.name}'s request to cancel</Modal.Title>
            </Modal.Header>
            <Form>
              <Modal.Body className="pt-0">
                <Form.Group className="form-group pt-3">
                  <Form.Label>Enter an explanation to send to {props.class.props.showCancelModal.collaborator.profile.name}:</Form.Label>
                  <Form.Control 
                    onChange={e => props.setReason(e.target.value)}
                    value={props.reason}
                    as="textarea"
                    id="message"
                    placeholder="Write your message here..."
                    rows={5}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer className="p-3 pt-0 border-0">
                <Button variant="outline-secondary" className="m-0 me-2" size="sm" onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant="danger" size="sm" className="m-0" disabled={props.class.props.isSubmitting}  type="submit" onClick={handleSubmit}>
                  {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cancelling...</> : "Decline Request"}
                </Button>
                {error && <div className="error text-danger small ms-3">{error}</div>}
              </Modal.Footer>
            </Form>
          </Modal>
        )
      }
      else {
        return (
          <Modal centered show={props.show} onHide={handleClose}>
            <Modal.Header className="bg-danger text-background" closeButton>
              <Modal.Title className="h6">Are you sure you want to cancel your collaboration with {props.class.props.showCancelModal.collaborator.profile.name}?</Modal.Title>
            </Modal.Header>
            <Form>
              <Modal.Body className="pt-0">
                <Form.Group className="form-group pt-3">
                  <Form.Label>Enter a message to send to {props.class.props.showCancelModal.collaborator.profile.name}:</Form.Label>
                  <Form.Control 
                    onChange={e => props.setReason(e.target.value)}
                    value={props.reason}
                    as="textarea"
                    id="message"
                    placeholder="Write your message here..."
                    rows={5}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer className="p-3 pt-0 border-0">
                <Button variant="outline-secondary" className="m-0 me-2" size="sm" onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant="danger" size="sm" className="m-0" disabled={props.class.props.isSubmitting}  type="submit" onClick={handleSubmit}>
                  {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cancelling...</> : "Cancel Collaboration"}
                </Button>
                {error && <div className="error text-danger small ms-3">{error}</div>}
              </Modal.Footer>
            </Form>
          </Modal>
        )
      }
    }
    else{
      return (<></>)
    }
  }

  CompletionModal(props){
    var error = null;
    const handleClose = e => {
      props.class.props.setCompletionModal({"visible":false,"collaborator":null})
      props.setReason(null)
    }
    const markComplete = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)

      var response = await apiCall(`campaign/bid/complete?id=${props.class.props.id}`,{ "method" : "PUT", "data" : {"bidID":props.class.props.showCompletionModal.collaborator.details.id,"message":props.reason} });
      if (response["success"]) {
        props.class.getCampaign(props.class.props.id)
        props.class.props.setSelectBids({});
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Collaboration Completion Confirmed","content":"The collaboration was confirmed as completed!","className":"bg-success text-background"})
        props.setReason(null)
        handleClose()
      }
      else {
        error = response["failure"]["error"]
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Error Confirming Collaboration Completion","content":error,"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    const markAsIncomplete = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)

      var response = await apiCall(`campaign/bid/incomplete?id=${props.class.props.id}`,{ "method" : "PUT", "data" : {"bidID":props.class.props.showCompletionModal.collaborator.details.id,"message":props.reason} });
      if (response["success"]) {
        props.class.getCampaign(props.class.props.id)
        props.class.props.setSelectBids({});
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Collaboration Incomplete Confirmed","content":"The collaboration was confirmed as incomplete.","className":"bg-success text-background"})
        props.setReason(null)
        handleClose()
      }
      else {
        error = response["failure"]["error"]
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Error Confirming Collaboration as Incomplete","content":error,"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    if (props.class.props.showCompletionModal.visible){
      return (
        <Modal centered show={props.show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="h6">Is your collaboration with {props.class.props.showCompletionModal.collaborator.profile.name} complete?</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body className="pt-0">
              <div>
                <p><strong>{props.class.props.showCompletionModal.collaborator.profile.name}</strong> marked this collaboration as complete.</p>
                <p>If you agree you can confirm by clicking on the "Confirm Completion" button below. However if you feel that they haven't completed the task or something else is stopping them from completing the collaboration, please click on the "Mark as Incomplete" button.</p>
                <p>You have an option to send one final message to the member as well - either to thank them or let them know what you still expect from them.</p>
              </div>
              <Form.Group className="form-group pt-3">
                <Form.Label>Enter a message to send to {props.class.props.showCompletionModal.collaborator.profile.name}:</Form.Label>
                <Form.Control 
                  onChange={e => props.setReason(e.target.value)}
                  value={props.reason}
                  as="textarea"
                  id="message"
                  placeholder="Write your message here..."
                  rows={5}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="p-3 pt-0 border-0">
              <Button variant="outline-secondary" className="m-0 me-2" size="sm" onClick={handleClose}>
                Cancel
              </Button>
              {!props.class.props.showCompletionModal.earlyComplete &&
                <Button variant="danger" size="sm" className="m-0 me-2" disabled={props.class.props.isSubmitting}  type="submit" onClick={markAsIncomplete}>
                  {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Marking...</> : "Mark as Incomplete"}
                </Button>
              }
              <Button variant="success" size="sm" className="m-0" disabled={props.class.props.isSubmitting}  type="submit" onClick={markComplete}>
                {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Confirming...</> : "Confirm Completion"}
              </Button>
              {error && <div className="error text-danger small ms-3">{error}</div>}
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    else{
      return (<></>)
    }
  }

  ConversationModal(props){
    var error = null;
    const handleClose = e => {
      props.class.props.setConversationModal({"visible":false,"conversationID":null,"user":null,"conversation":null,"messages":[]})
      props.class.setState({conversationLoaded: false})
    }
    const AlwaysScrollToBottom = () => {
      const elementRef = useRef();
      useEffect(() => { 
        if (props.class.props.autoScroll)
        {
          elementRef.current.scrollIntoView()
        }
      });
      return <div ref={elementRef} />;
    }
    const chatAreaScroll = e  => {
      const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight - 10 & e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;
      if (bottom) {
        props.class.props.setAutoScroll(true)
      } else {
        props.class.props.setAutoScroll(false)
      }
    }
    if (props.class.props.conversationModal.visible){
      if (!props.class.state.conversationLoaded){
        props.class.getConversation(props.class.props.conversationModal.conversationID)
      }
      else {
        var recipient = {"name":"unknown","profileImage":"None"}
        var me = {"id":"","name":"unknown","profileImage":"None"}
        var participantType = null
        props.class.props.conversationModal.conversation.participants.forEach(function (participant) {
          if (!participant.hasOwnProperty("me")){
            recipient = participant.details // We'll need to handle maybe group conversations in the future? Not sure if really needed...
          }
          else {
            me = participant.details
            participantType = participant.type
          }
        })
      }
      return (
        <Modal centered show={props.class.props.conversationModal.visible} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="h5">Message {props.class.props.conversationModal.user.profile.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 campaignConversationModal">
            {props.class.state.conversationLoaded ? (
            <div className="chatBox shadow-sm rounded-bottom h-100 ">
              <div className="chatBody">
                <div className="chatArea" onScroll={chatAreaScroll}>
                  <div className="text-center text-muted py-3 small">These are the latest messages between you and {recipient.name}</div>
                  {[...props.class.props.conversationModal.messages].reverse().map(message => (
                    <span key={message._id}>
                      {message.messageType == "update" ? (
                        <div className="text-center text-muted py-3 small">
                          {message.contents}
                          <span className="smaller ps-2">({relativeTimeFormat(message.messageTime*1000)})</span>
                        </div>
                      ) :
                      (
                      <>
                      <div className={message.sender != me._id ? "bubbleLeft" : "bubbleRight"}>
                        <div className={message.sender != me._id ? "bubbleLeftBoxes" : "bubbleRightBoxes"}>
                          <div className={message.sender != me._id ? "bubbleLeftText" : "bubbleRightText"}>

                            {message.messageType == "image" && <div className="imagesBoxView h-auto me-1 cursor-pointer"><img src={getImageUrl(props.class.props.providers,message.contents,["w_250","c_scale"])} className="object-fit-cover rounded-xl mt-2 me-2 mb-2 w-100" height="100px" alt={`Image from ${recipient.name}`} onClick={() => {props.class.props.setShowCarousel({visible:true,image:message.contents})}} aria-controls="imageViewer" /></div>}

                            {message.messageType == "file" && <div><a href={getFileUrl(props.class.props.providers,message.contents)} download={message.contents.name}><img src={Document} height="60px" className="object-fit-contain rounded" alt={`Document from ${recipient.name}`} /></a>{message.contents.name}</div>}
                            {message.messageType == "video" && <div><a href={getVideoURL(props.class.props.providers,message.contents)}><img src={Video} height="60px" className="object-fit-contain rounded" alt={`Document from ${recipient.name}`} /></a></div>}
                            {message.messageType == "text" && formatText(message.contents)}
                            <div className={message.sender != me._id ? "smaller text-muted text-nowrap pt-1" : "smaller text-nowrap pt-1" }>
                            {relativeTimeFormat(message.messageTime*1000)} <img className="ms-1" src={message.sender != me._id ? grayDoubleChecks : whiteDoubleChecks }/>
                            </div>
                          </div>
                        </div>
                      </div>
                      </>
                      )}
                    </span>
                    )
                  )}         
                    <AlwaysScrollToBottom />    
                    {props.class.props.showCarousel.visible && (
                      <Fade in={props.class.props.showCarousel.visible}>
                        <div className="campaignImagePreview" id="imageViewer">
                          <div className="carouselControl">
                            <a href={getImageUrl(props.class.props.providers, props.class.props.showCarousel.image,null,true)} download target="_blank" className="btn btn-sm btn-success">Download</a>
                            <button type="button" onClick={() => props.class.props.setShowCarousel({visible:false,image:null})} className="btn btn-sm btn-light closeImageViewer">Close</button>
                          </div>
                          <Carousel>
                            <Carousel.Item>
                              <img id="0" className="d-block rounded-xl" src={getImageUrl(props.class.props.providers, props.class.props.showCarousel.image,["w_500","c_scale"])} alt={props.class.props.showCarousel.image.name} />
                            </Carousel.Item>
                          </Carousel>
                        </div>
                      </Fade> 
                    )}
                  </div>
                </div>
              <div className="chatFooter border-top">
                <div className="position-relative d-flex justify-content-center">
                  <Alert variant="light" className="d-flex align-items-center justify-content-between border-gray px-3 p-2 alertBar shadow-sm border">
                    <a onClick={() => {props.class.goToMessage(props.class.props.conversationModal.conversationID); handleClose()}} className="text-primary fw-500 small text-nowrap">Go To Full Conversation</a>
                  </Alert>
                </div>
                <SendMessageForm recipient={recipient} conversationID={props.class.props.conversationModal.conversationID} sender={me._id} showConversation={props.class.getConversation}/>
              </div>
            </div>
            ) : (
              <div className="col-12 px-0 conversationDetail">
              <InboxLoader key={"empty"}/>
            </div>
            )}
          </Modal.Body>
        </Modal>
      )}
    else {
      return (<></>)
    }
  }

  RejectModal(props){ 
    var error = null;
    const handleSubmit = async e => {
      e.preventDefault();
      props.class.props.setIsSubmitting(true)

      var response = await apiCall(`campaign/bid/reject?id=${props.class.props.id}`,{ "method" : "PUT", "data" : {"bids":Object.keys(bids),"message":props.reason} });
      if (response["success"]) {
        props.class.getCampaign(props.class.props.id)
        props.class.props.setSelectBids({});
        props.class.props.setReason(null)
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Bids Rejected","content":"All bids were rejected successfully","className":"bg-success text-background"})
        props.handleClose()
      }
      else {
        error = response["failure"]["error"]
        props.class.props.setAlert({"display":"toast","visible":true,"title":"Error Rejecting Bids","content":error,"className":"bg-danger text-background"})
      };
      props.class.props.setIsSubmitting(false)
    }
    const bids = props.class.props.selectBids;
    var bid = {};
    if (Object.keys(bids).length > 0){
      if (Object.keys(bids).length == 1){
        var bid = bids[Object.keys(bids)[0]]
      }
      return (
        <Modal centered show={props.show} onHide={props.handleClose}>
          <Modal.Header className="bg-danger text-background" closeButton>
            <Modal.Title className="h6">Are you sure you want to decline {Object.keys(bids).length == 1 ? bid.profile.name : Object.keys(bids).length + " bids"}?</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body className="pt-0">
              <Row className="selectedBids">
                {Object.keys(bids).length > 1 && Object.entries(bids).map((bidder, index) => (
                  <div class="col-6 d-flex align-items-center small pt-3" key={bidder[0]}>
                    <img src={getImageUrl(props.class.props.providers,bidder[1].profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" width="42px" className="border rounded me-2" />
                    <span>{bidder[1].profile.name}</span>
                  </div>
                ))}
              </Row>
              <Form.Group className="form-group pt-3">
                <Form.Label>Enter a message to send to {Object.keys(bids).length == 1 ? bid.profile.name : "all selected bids"}:</Form.Label>
                <Form.Control 
                  onChange={e => props.setReason(e.target.value)}
                  value={props.reason}
                  as="textarea"
                  id="message"
                  placeholder="Write your message here..."
                  rows={5}
                />
                {Object.keys(bids).length > 1 && <p className="small mt-2 mb-0">Please note that the message written will be sent to all selected bidders.</p>}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="p-3 pt-0 border-0">
              <Button variant="outline-secondary" className="m-0 me-2" size="sm" onClick={props.handleClose}>
                Cancel
              </Button>
              <Button variant="danger" size="sm" className="m-0" disabled={props.class.props.isSubmitting}  type="submit" onClick={handleSubmit}>
                {props.class.props.isSubmitting ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Declining...</> : "Decline Bids"}
              </Button>
              {error && <div className="error text-danger small ms-3">{error}</div>}
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    else{
      return (<></>)
    }
  }


  BidderCard(props) {
  const bidDate = getDifference(props.bidder.details.time)
  const age = getAge(props.bidder.profile.dob)

  const isFavourited = (props.bidder.details.hasOwnProperty("favourite") && props.bidder.details.favourite == true);
    return (
      <div>
        <div className={`mb-3 ${props.class.props.openCards.hasOwnProperty(props.bidder.details.id) ? "hide" : ""}`}  key={`${props.bidder.details.id}-small`}>
          <Card className={`shadow-sm ${props.bidder.details.hasOwnProperty("recommended") && props.bidder.details.recommended == true ? "recommendedCard" : ""}`}>
          {(props.bidder.details.hasOwnProperty("recommended") && props.bidder.details.recommended == true) && <Badge bg="info" className="recommendedBadge">Recommended</Badge> }
            <Card.Header className="py-3 d-flex align-items-center">
              {["pending","recommended","favourites"].includes(props.class.props.bidsTab) && (
                <input type="checkbox" className="form-check-input me-3 mt-0" onChange={() => props.class.updateSelectedBids(props.bidder)} checked={Object.entries(props.class.props.selectBids).filter(([key]) => key == props.bidder.details.id).length > 0}/>
              )}
              <img src={getImageUrl(props.class.props.providers,props.bidder.profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" width="42px" className="rounded cursor-pointer" onClick={()=>(props.class.toggleCardView(props.bidder.details.id,props.bidder.details.bidderID))} />
              <div className="ms-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="mb-0 cursor-pointer fw-bold card-title" onClick={()=>(props.class.toggleCardView(props.bidder.details.id,props.bidder.details.bidderID))} >{props.bidder.profile.name} {(props.bidder.profile.hasOwnProperty("muted") && props.bidder.profile.muted == true) && <Badge bg="warning" className="mutedBadge">Muted</Badge> }</div>
                  <div className="cardToggles">
                    {isFavourited ? <div className="cursor-pointer favouriteToggle" onClick={(e) => {e.preventDefault(); props.class.unfavouriteBid(props.bidder.details.id)}} ><img src={starYellow} /></div> : <div className="cursor-pointer favouriteToggle" onClick={(e) => {e.preventDefault(); props.class.favouriteBid(props.bidder.details.id)}} ><img src={starGrey} /></div>}
                    <div className="cursor-pointer" onClick={()=>(props.class.toggleCardView(props.bidder.details.id,props.bidder.details.bidderID))} ><img src={info} /></div>
                  </div>
                </div>
                <Card.Text className="text-muted">
                  <span>{age} years old</span>
                  <span className="mx-3">{props.bidder.profile.gender}</span>
                  <span>{props.bidder.profile.address.city}</span>
                </Card.Text>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="card-text">
                <div className="d-flex flex-column text-truncate">
                  <div className="mb-3 text-nowrap">                                    
                    <div className="mb-1 tagsTitle">Primary Category:</div>
                    <span className="tags">{props.bidder.profile.interests[0]}</span>
                  </div>
                  <div className="text-nowrap">                                    
                    <div className="mb-1 tagsTitle">Interests:</div>
                    {props.bidder.profile.interests.length <= 3 ? 
                    (
                      <>
                      {props.bidder.profile.interests.map((interest, index) => (<span key={props.bidder.details.id + index + interest} className="tags me-1">{interest}</span>))}
                      </>
                    ) :
                      <>
                      {props.bidder.profile.interests.slice(0,2).map((interest, index) => (<span key={props.bidder.details.id + index + interest} className="tags me-1">{interest}</span>))}
                      <span className="tags fw-bold cursor-pointer" onClick={()=>(props.class.toggleCardView(props.bidder.details.id,props.bidder.details.bidderID))}>+{props.bidder.profile.interests.length - 2}</span>
                      </>
                    }
                  </div>
                </div>
                <div className="mt-3">
                  <div className="mb-1 smaller fw-500">Bid Message</div>
                  <p className="mb-0 smaller twoLineTruncate">{props.bidder.details.message}</p>
                </div>
                {props.class.state.campaign.hasBudget && (
                  <div className="mt-3">
                    <h6 className="mb-1 smaller fw-500">Proposed Fee</h6>
                    <p className="mb-0 small twoLineTruncate">{props.class.state.campaign.budget.currency == "GBP" ? "£" : "$"}{props.bidder.details.fee}</p>
                  </div>
                )}
              </div>
            </Card.Body>
            <Card.Footer className="d-flex align-items-center justify-content-between">
              <div className="text-muted small">{bidDate.difference} {bidDate.unit} ago</div>
              {["pending","recommended","favourites"].includes(props.class.props.bidsTab) && (
                <>
                <Dropdown>
                  <button type="button" onClick={() => { props.class.props.setConversationModal({"visible":true,"conversationID":props.bidder.details.conversationID,"user":props.bidder}); props.class.props.setAutoScroll(true); } } className="btn btn-sm btn-outline-primary">
                    Message
                  </button>
                  <Dropdown.Toggle className="btn btn-sm btn-outline-primary" />
                  <Dropdown.Menu>
                    {(props.bidder.profile.hasOwnProperty("muted") && props.bidder.profile.muted == true) ?
                      <a href="#" onClick={(e) => {e.preventDefault(); props.class.unmuteBid(props.bidder.details.id)}} className="dropdown-item">Unmute</a>
                    :
                      <a href="#" onClick={(e) => {e.preventDefault(); props.class.muteBid(props.bidder.details.id)}} className="dropdown-item">Mute</a>
                    }
                    {(props.bidder.details.hasOwnProperty("favourite") && props.bidder.details.favourite == true) ?
                      <a href="#" onClick={(e) => {e.preventDefault(); props.class.unfavouriteBid(props.bidder.details.id)}} className="dropdown-item">Unfavourite</a>
                    :
                      <a href="#" onClick={(e) => {e.preventDefault(); props.class.favouriteBid(props.bidder.details.id)}} className="dropdown-item">Favourite</a>
                    }
                  </Dropdown.Menu>
                </Dropdown>
                
                </>
              )}
              {(props.class.props.bidsTab === "cancelled" && props.bidder.details.state == "Pending Cancellation") && (
                <>
                  <button type="button" onClick={() => { props.class.props.setCancelModal({"visible":true,"collaborator":props.bidder,"rejecting":true}) } } className="btn btn-sm btn-outline-danger ms-2">
                    Reject Cancellation
                  </button> 
                  <button type="button" onClick={() => { props.class.props.setCancelModal({"visible":true,"collaborator":props.bidder,"rejecting":false}) } } className="btn btn-sm btn-outline-success ms-2">
                    Confirm Cancellation
                  </button>                
                </>
              )}
              {(props.bidder.details.hasOwnProperty("referrer") && props.bidder.details.referrer != null) && (
              <div>
                <span className="fw-500 small">Referred by: </span>
                <span className="fw-normal text-muted small">{props.bidder.details.referrer}</span>
              </div>
              )}
            </Card.Footer>
          </Card>
        </div>
        <Card className={`mb-md-4 shadow-sm mb-3 ${!props.class.props.openCards.hasOwnProperty(props.bidder.details.id) ? "hide": ""}`} key={props.bidder.details.id}>
          <Card.Header>
            <div className="d-flex align-items-center justify-content-between">
              {["pending","recommended","favourites"].includes(props.class.props.bidsTab) && (
                <input type="checkbox" className="form-check-input me-3 mt-0" onChange={() => props.class.updateSelectedBids(props.bidder)} checked={Object.entries(props.class.props.selectBids).filter(([key]) => key == props.bidder.details.id).length > 0}/>
              )}
              <h6 className="my-2">{props.bidder.profile.name}'s Profile</h6>
              <a className="cursor-pointer text-dark" onClick={()=>(props.class.toggleCardView(props.bidder.details.id))}>✖</a>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="d-flex align-items-start mb-3">
              <Image src={getImageUrl(props.class.props.providers,props.bidder.profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" className="me-3 border rounded" width="90px" />
              <div>
                <h5 className="mb-0">{props.bidder.profile.name}</h5>
                <div className="small mb-2 text-muted">{age} years old • {props.bidder.profile.gender} • {props.bidder.profile.address.city}</div>
                <div className="small">
                </div>
              </div>
            </div>
            <div className="border-top pt-3 mb-3 aboutYouBox">
              <h6 className="mb-3">About</h6>
              <div className="d-flex align-items-center mt-2">
                {withinAgeRange(props.bidder.profile.dob,props.class.state.campaign.criteria.ages).match ? <img src={checkGreen} className="me-2" width="20px" /> : <img src={checkGrey} className="me-2" width="20px" />} <img src={Avatar} width="18px" height="16px" className="me-2 avatarIcon" /> {withinAgeRange(props.bidder.profile.dob,props.class.state.campaign.criteria.ages).range}
              </div>
            </div>
            <div className="border-top pt-3 mb-3">
              <h6 className="mb-3">Primary Category & Interests</h6>
              <div>
                <div className="mb-3 text-nowrap">                                    
                  <div className="mb-1 tagsTitle">Primary Category:</div>
                  <span className="tags">{props.bidder.profile.interests[0]}</span>
                </div>
                <div>                                    
                  <div className="mb-1 tagsTitle">Interests:</div>
                  {props.bidder.profile.interests.map((interest, index) => (<span key={interest+index} className="tags me-1 text-nowrap mb-1 d-inline-block">{interest}</span>))}
                </div>
              </div>
            </div>
          
            <div className="border-top pt-3 mb-3">
              <h6 className="mb-2">Bid Message</h6>
              <p className="mb-0 small">{props.bidder.details.message}</p>
            </div>
            {props.class.state.campaign.hasBudget && (
              <div className="border-top pt-3">
                <h6 className="mb-2">Proposed Fee</h6>
                <p className="mb-0 small">{props.class.state.campaign.budget.currency == "GBP" ? "£" : "$"}{props.bidder.details.fee}</p>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }

  goToMessage(conversationID) {
    this.props.setTabID("messages")
    this.props.setConversationID(conversationID);
    this.props.setAutoScroll(true);
  }



  async stopNotifications(bidderID){
    var response = await apiCall(`campaign/stopNotifications?id=${this.props.id}&bidderID=${bidderID}`,{ "method" : "GET" });
      if (response["success"]) {
        this.getCampaign(this.props.id)
      }
  }

  async markAsSent(bidID){
    var response = await apiCall(`campaign/bid/markAsSent?id=${this.props.id}`,{ "method" : "PUT", "data" : {"bidID":bidID} });
      if (response["success"]) {
        this.getCampaign(this.props.id)
      }
  }



  toggleCardView(id,bidderID=null){
    var openCards = this.props.openCards;
    console.log(id, openCards, bidderID)
    if (openCards.hasOwnProperty(id)) {
      openCards = Object.fromEntries(Object.entries(openCards).filter(([key]) => key != id)); //If we don't add this, state doesn't update :) 
    }
    else {
      openCards[id] = 0
      openCards = Object.fromEntries(Object.entries(openCards).filter(([key]) => key != null)); //If we don't add this, state doesn't update :) 

    }
    this.props.setOpenCards(openCards);
  }

  CollaboratorCard(props) {
    const age = getAge(props.collaborator.profile.dob);
    const contributionSummary = getContributionList(props.collaborator.details.contributions)

    var address = [];
    if (props.collaborator.profile.address != {}){
        ["address1","address2","city","region","postcode"].forEach(line => {
        if (props.collaborator.profile.address[line] && props.collaborator.profile.address[line].length > 0){
          address.push(props.collaborator.profile.address[line])
        }
      })
    }

    return (
      <div>
        <Card className={`shadow-sm mb-3 ${props.class.props.openCards.hasOwnProperty(props.collaborator.details.id) ? "hide" : ""}`}>
          <Card.Body>
            <div className="d-flex align-items-start flex-column">
              <div className="d-flex align-items-center">
                <img src={getImageUrl(props.class.props.providers,props.collaborator.profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" width="24px" className="rounded cursor-pointer me-2" onClick={()=>(props.class.toggleCardView(props.collaborator.details.id,props.collaborator.details.bidderID))} />
                <div className="mb-0 cursor-pointer fw-bold card-title" onClick={()=>(props.class.toggleCardView(props.collaborator.details.id,props.collaborator.details.bidderID))}>{props.collaborator.profile.name}</div>
                <div className="cursor-pointer position-absolute top-0 mt-3 end-0 me-3" onClick={()=>(props.class.toggleCardView(props.collaborator.details.id,props.collaborator.details.bidderID))}><img src={info} /></div>
              </div>                
            </div>
            <Alert variant="secondary" className="px-2 py-1 smaller">
              <div className="d-flex align-items-center justify-content-between w-100">
                <div>        
                  {props.collaborator.details.state == "Completed" && (
                    <div>Completed date: <strong>{new Date(props.collaborator.details.completionTime*1000).toLocaleDateString('en-GB', { year:"numeric", month:"long", day:"numeric"})}</strong></div>
                  )}
                  {props.collaborator.details.state == "Marked as Complete" && (
                    <div>Status: <strong>Awaiting Completion Verification</strong></div>
                  )}
                  {props.collaborator.details.state == "In Progress" && (
                    <div>Status: <strong>In Progress</strong></div>
                  )}
                  {props.collaborator.details.state == "Accepted" && (
                    <div>Status: <strong>Accepted</strong></div>
                  )}
                </div>
              </div>
            </Alert>
            <div className="mt-3 d-flex align-items-start small flex-wrap">

            </div>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <a>
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Report</Tooltip>}>
                    <img src={blueAlert} className="me-3" height="18px" />
                  </OverlayTrigger>
                </a>
                <OverlayTrigger trigger="click" placement="top" rootClose
                  overlay={
                    <Popover>
                      <Popover.Header as="h3">Contact Details</Popover.Header>
                      <Popover.Body>
                        <div className="small">
                          <span className="text-muted">Address:</span>
                          <div className="mb-2">{address.join(", ")}</div>
                          {props.collaborator.profile.hasOwnProperty("phoneNumber") && props.collaborator.profile.phoneNumber && (
                            <>
                            <span className="text-muted">Phone Number:</span>
                            <div className="mb-2">{props.collaborator.profile.phoneNumber}</div>
                            </>
                          )}
                          {props.collaborator.profile.hasOwnProperty("email") && props.collaborator.profile.email && (
                            <>
                            <span className="text-muted">Email:</span>
                            <div className="mb-2">{props.collaborator.profile.email}</div>
                            </>
                          )}
                        </div>
                      </Popover.Body>
                    </Popover>
                  }>                                  
                  <img className="cursor-pointer" src={blueProfileCard} height="18px" />
                </OverlayTrigger>
              </div>
              <div>
                <Dropdown>
                  <button type="button" onClick={() => { props.class.props.setConversationModal({"visible":true,"conversationID":props.collaborator.details.conversationID,"user":props.collaborator}); props.class.props.setAutoScroll(true); } } className="btn btn-sm btn-outline-primary">Message</button>
                  <Dropdown.Toggle className="btn btn-sm btn-outline-primary" />
                  <Dropdown.Menu>
                    {props.collaborator.details.state != "Completed" && props.collaborator.details.state != "Marked as Complete" && (<><button type="button" onClick={() => { props.class.props.setCompletionModal({"visible":true,"collaborator":props.collaborator,"earlyComplete":true}); props.class.props.setReason("") }} className="dropdown-item">Complete Bid</button><button type="button" onClick={() => { props.class.props.setCancelModal({"visible":true,"collaborator":props.collaborator,"rejecting":false}); props.class.props.setReason("") }} className="dropdown-item">Cancel Bid</button></>)}
                    {props.collaborator.details.state == "Marked as Complete" && <button type="button" onClick={() => { props.class.props.setCompletionModal({"visible":true,"collaborator":props.collaborator}); props.class.props.setReason("") }} className="dropdown-item">Verify Completion</button>}
                    {(!props.collaborator.details.hasOwnProperty("deliveryState") || props.collaborator.details.deliveryState == "unsent") && !props.campaign.event && <button type="button" onClick={() => { props.class.markAsSent(props.collaborator.details.id) }} className="dropdown-item">Mark as Sent</button>}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            {!props.collaborator.details.hasOwnProperty("deliveryState") ? getDeliveryStatus("unsent") : getDeliveryStatus(props.collaborator.details.deliveryState)}
          </Card.Footer>
        </Card>  
        <Card className={`mb-md-4 shadow-sm mb-3 ${!props.class.props.openCards.hasOwnProperty(props.collaborator.details.id) ? "hide": ""}`}>
          <Card.Header>
            <div className="d-flex align-items-center justify-content-between">
              <h6 className="my-2">{props.collaborator.profile.name}'s Profile</h6>
              <a className="cursor-pointer text-dark" onClick={()=>(props.class.toggleCardView(props.collaborator.details.id))}>✖</a>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="d-flex align-items-start mb-3">
              <Image src={getImageUrl(props.class.props.providers,props.collaborator.profile.profileImage,["w_80","h_80","c_scale"])} alt="avatar" className="me-3 border rounded" width="90px" />
              <div>
                <h5 className="mb-0">{props.collaborator.profile.name}</h5>
                <div className="small mb-2 text-muted">{age} years old • {props.collaborator.profile.gender} • {props.collaborator.profile.address.city}</div>
                <div className="small">

                </div>
              </div>
            </div>
            <div className="border-top pt-3 mb-3 aboutYouBox">
              <h6 className="mb-3">About</h6>
              <div className="d-flex align-items-center mt-2">
                {withinAgeRange(props.collaborator.profile.dob,props.class.state.campaign.criteria.ages).match ? <img src={checkGreen} className="me-2" width="20px" /> : <img src={checkGrey} className="me-2" width="20px" />} <img src={Avatar} width="18px" height="16px" className="me-2" /> {withinAgeRange(props.collaborator.profile.dob,props.class.state.campaign.criteria.ages).range}
              </div>
            </div>
            <div className="border-top pt-3 mb-3">
              <h6 className="mb-3">Primary Category & Interests</h6>
              <div>
                <div className="mb-3 text-nowrap">                                    
                  <div className="mb-1 tagsTitle">Primary Category:</div>
                  <span className="tags">{props.collaborator.profile.interests[0]}</span>
                </div>
                <div>                                    
                  <div className="mb-1 tagsTitle">Interests:</div>
                  {props.collaborator.profile.interests.map((interest, index) => (<span key={interest+index} className="tags me-1 text-nowrap mb-1 d-inline-block">{interest}</span>))}
                </div>
              </div>
            </div>
            <div className="border-top pt-3 mb-3">
              <h6 className="mb-2">Bid Message</h6>
              <p className="mb-0 small">{props.collaborator.details.message}</p>
            </div>
            
            {props.campaign.hasBudget && (
              <div className="border-top pt-3">
                <h6 className="mb-2">Proposed Fee</h6>
                <p className="mb-0 small">{props.campaign.budget.currency == "GBP" ? "£" : "$"}{props.collaborator.details.fee}</p>
              </div>
            )}
            {(props.campaign.campaignType == "sampling" || props.campaign.campaignType == "content") && contributionSummary.length > 0 && (
              <div className="border-top pt-3">
                <h6 className="mb-2">Submitted Content</h6>
                {props.collaborator.details.contributions.filter(function(contribution) {return contribution.assetType == "link"}).map(contribution => 
                  <><a href={contribution.assetUrl} target="_blank" key={contribution.key}>{contribution.assetUrl}</a><br /></>
                )}
                {props.collaborator.details.contributions.filter(function(contribution) {return contribution.assetType != "link"}).map(contribution => 
                  <>
                  {contribution.assetType == "video" ? 
                    <video key={contribution.id} src={getImageUrl(props.class.props.providers,contribution.assetUrl,["w_80","h_80","c_scale"],false,true)} alt="avatar" className="me-3 border rounded cursor-pointer" width="90px" onClick={() => {props.class.props.setShowCarousel({visible:true,image:contribution.assetUrl})}} />
                  :
                    <Image key={contribution.id} src={getImageUrl(props.class.props.providers,contribution.assetUrl,["w_80","h_80","c_scale"])} alt="avatar" className="me-3 border rounded cursor-pointer" width="90px" onClick={() => {props.class.props.setShowCarousel({visible:true,image:contribution.assetUrl})}} />
                  }</>
                )}
              </div>
            )}
            {props.class.props.showCarousel.visible && (
              <Fade in={props.class.props.showCarousel.visible}>
                <div id="imageViewer">
                  <div className="carouselControl">
                  <a href={getImageUrl(props.class.props.providers, props.class.props.showCarousel.image,null,true,props.class.props.showCarousel.image.type == "video")} download target="_blank" className="btn btn-sm btn-success">Download</a>
                    <button type="button" onClick={() => props.class.props.setShowCarousel({visible:false,image:null})} className="btn btn-sm btn-light closeImageViewer">Close</button>
                  </div>
                <Carousel>
                  <Carousel.Item>
                    {props.class.props.showCarousel.image.type == "video" ? 
                      <video id="0" autoPlay loop controls className="d-block rounded-xl" src={getImageUrl(props.class.props.providers, props.class.props.showCarousel.image,["w_500","c_scale"],false,true)} alt={props.class.props.showCarousel.image.name} />
                    :
                      <img id="0" className="d-block rounded-xl" src={getImageUrl(props.class.props.providers, props.class.props.showCarousel.image,["w_500","c_scale"])} alt={props.class.props.showCarousel.image.name} />
                    }
                  </Carousel.Item>
                </Carousel>
                </div>
              </Fade> 
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }

  BidsView(props) {
    const handleAcceptClose = () => props.setShowAcceptModal(false);
    const handleAcceptShow = () => { 
      props.setShowAcceptModal(true); 
      props.setReason("");
    }
    const handleRejectClose = () => props.setShowRejectModal(false);
    const handleRejectShow = () => { 
      props.setShowRejectModal(true);
      props.setReason("Thank you for your interest in this listing, but unfortunately you have not been successful this time. Keep an eye out for new listings from us in the future!");
    }
    const breakpointColumnsObj = {
      default: 3,
      1100: 2,
      700: 1
    }
    const recommendedBids = props.class.props.bids.filter(function(bid) {return bid.details.recommended})
    const favouriteBids = props.class.props.bids.filter(function(bid) {return bid.details.favourite})
    return (
      <>
        <Container className="px-0 pt-2">
          <Row className="px-3">
            <div className="col-12">
              <div className="tab-content" id="nav-tabContent">
                <div className="tab-pane fade" id="all" role="tabpanel" aria-labelledby="all-tab">...</div>
    
                <div className="tab-pane fade show active" id="collaborations" role="tabpanel" aria-labelledby="collaborations-tab">
                  <Row className="pt-2 position-relative">
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Tabs defaultActiveKey="pending" id="uncontrolled-tab-example" onSelect={tab => (props.class.props.setBidsTab(tab))}>
                        {recommendedBids.length > 0 && <Tab eventKey="recommended" title={`Recommended (${recommendedBids.length})`}>
                        </Tab>}
                        <Tab eventKey="favourites" disabled={favouriteBids.length == 0} title={`Favourites (${favouriteBids.length})`}>
                        </Tab>
                        <Tab eventKey="pending" title={`Pending (${props.class.props.bids.length})`}>
                        </Tab>
                        <Tab eventKey="rejected" disabled={props.class.props.rejectedBids.length == 0} title={`Declined (${props.class.props.rejectedBids.length})`}>
                        </Tab>
                        <Tab eventKey="cancelled" disabled={props.class.props.cancelledBids.length == 0} title={`Cancelled (${props.class.props.cancelledBids.length})`}>
                        </Tab>
                      </Tabs>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Row>
        </Container>
        {["pending","recommended","favourites"].includes(props.class.props.bidsTab) && 
          <Container className="border-bottom d-none d-xl-block position-relative" fluid>
            <Container className="px-0 text-nowrap">
              <div className="p-3 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="me-4 small text-muted">
                    <input type="checkbox" className="form-check-input me-1" onChange={props.class.handleSelectAllBids} checked={props.class.props.selectAllBids} />
                    {(() => {
                      const visibleBids = props.class.getVisibleBids();
                      const selectedCount = Object.keys(props.class.props.selectBids).filter(id => visibleBids.some(bid => bid.details.id == id)).length;
                      return `Select all (${selectedCount}/${visibleBids.length})`;
                    })()}
                  </div>
                  <div className="me-4 pe-3 small text-muted">
                    <input type="checkbox" className="form-check-input me-1" onChange={props.class.handleSelectRecommendedBids} checked={props.class.props.selectRecommendedBids} />
                    {(() => {
                      const visibleRecommendedBids = props.class.getVisibleBids({ recommended: true });
                      const selectedCount = Object.keys(props.class.props.selectBids).filter(id => visibleRecommendedBids.some(bid => bid.details.id == id)).length;
                      return `Select all recommended (${selectedCount}/${visibleRecommendedBids.length})`;
                    })()}
                  </div>
                  <div className="me-4 pe-3 small text-muted">
                    <input type="checkbox" checked={props.class.props.filters.previousBidderOnly} className="form-check-input me-1" onChange={event => props.class.handleFilterUpdate(event,"previousBidders")} /> Show Known Bidders
                  </div>
                  <div className="me-3 small text-muted d-flex align-items-center">
                    <div className="text-nowrap me-2">Sort by:</div>
                    <Form.Select aria-label="Sort By" className="me-2 w-auto form-select-sm" value={props.class.props.sortBy} onChange={props.class.handleSortBy}>
                      <option value="createdAt">Creation Date</option>
                      <option value="age">Age</option>

                    </Form.Select>
                    <Form.Select aria-label="Sort Order" className="me-2 w-auto form-select-sm" value={props.class.props.orderBy} onChange={props.class.handleOrderBy}>
                      <option value="ascending">Ascending</option>
                      <option value="descending">Descending</option>
                    </Form.Select>
                    <Button variant="default" size="sm" className="bg-background border me-2" onClick={() => props.class.props.setShowFilter(props.class.props.showFilter != "simple" ? "simple" : "advanced")}>
                      Filters <img src={filter} className="ms-1" width="14px" />
                    </Button>
                    <Button variant="default" size="sm" className="bg-background border" onClick={() => {var tempSavedFilter = structuredClone(props.class.props.savedFilters); tempSavedFilter.visible = true; props.class.props.setSavedFilters(tempSavedFilter)}}>
                      Saved Filters <img src={props.class.props.savedFilters.selected ? starYellow : starGrey} className="ms-1" width="14px" />
                    </Button>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <InputGroup size="sm" className="me-3">
                    <Form.Control placeholder="Search" className="border-end-0" aria-label="Search" defaultValue={props.class.props.filters.search} onChange={e => props.class.handleFilterUpdate(e,"search")} />
                    <InputGroup.Text className="bg-background border-end">
                      <a><img src={searchBlue} /></a>
                    </InputGroup.Text>
                  </InputGroup>
                  <div className="fw-bold text-nowrap">Total Bids: {props.class.props.bids.length}</div>
                </div>
              </div>
            </Container>
            {props.class.props.showFilter != "simple" && (
            <>
              <div className="position-relative">                
                <button type="button" onClick={() => props.class.props.setShowFilter(props.class.props.showFilter != "simple" ? "simple" : "advanced")} className="btn btn-sm btn-danger mb-3 closeFilters"><img src={closeIcon} /></button>
                <div className="advanceFilters shadow">
                  <div className="mb-4">
                    <label className="fw-bold">Popular Ranges</label>
                    <div className="mt-2">
                      <div className="small text-muted mb-3">
                        <div className="d-flex align-items-center">
                          <div className="w-50">Minimum Age </div><input type="range" id="min" className="mx-2" min={18} max={props.class.props.filters.ages.max} value={props.class.props.filters.ages.min} onChange={event => props.class.handleFilterUpdate(event,"ages")} /> {props.class.props.filters.ages.min}
                        </div>
                      </div>
                      <div className="small text-muted mb-3">
                        <div className="d-flex align-items-center">
                        <div className="w-50">Maximum Age </div><input type="range" id="max" className="mx-2" min={props.class.props.filters.ages.min} max={100} value={props.class.props.filters.ages.max} onChange={event => props.class.handleFilterUpdate(event,"ages")} /> {props.class.props.filters.ages.max}
                        </div>
                      </div>
                      <div className="small text-muted mb-3">
                    </div>
                  </div>
                </div>
               <div className="small text-muted mb-3">
                <div className="d-flex align-items-center">
                  <div className="w-50">Min Fee</div>
                  <input
                    type="number"
                    className="form-control form-control-sm mx-2"
                    style={{width: 80}}
                    min={0}
                    id="minFee"
                    value={props.class.props.filters.fee?.minFee ?? ""}
                    placeholder="Min"
                    onChange={e => props.class.handleFilterUpdate(e, "fee")}
                  />
                </div>
              </div>
              <div className="small text-muted mb-3">
                <div className="d-flex align-items-center">
                  <div className="w-50">Max Fee</div>
                  <input
                    type="number"
                    className="form-control form-control-sm mx-2"
                    style={{width: 80}}
                    min={0}
                    id="maxFee"
                    value={props.class.props.filters.fee?.maxFee ?? ""}
                    placeholder="Max"
                    onChange={e => props.class.handleFilterUpdate(e, "fee")}
                  />
                </div>
              </div>
                  <div className="mb-2">
                    <div className="d-flex align-items-center flex-wrap text-muted mt-2">
                      <div className="d-flex align-items-center form-check form-switch me-3">
                        <label className="form-check-label mb-2">
                          <input type="checkbox" id="muted" className="form-check-input mt-1 me-2" checked={props.class.props.filters.muted == true} onChange={event => props.class.handleFilterUpdate(event,"muted")} /> Show Muted Members
                        </label>
                      </div>
                      <div className="d-flex align-items-center form-check form-switch me-3">
                        <label className="form-check-label mb-2">
                          <input type="checkbox" id="favourite" className="form-check-input mt-1 me-2" checked={props.class.props.filters.favourite == true} onChange={event => props.class.handleFilterUpdate(event,"favourite")} /> Show Favourite Members
                        </label>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mb-3">
                      <div className="form-group mb-3">
                        <label>Cities</label>
                        <div className="small text-muted">
                          <Select
                            closeMenuOnSelect={false}
                            components={props.class.props.animatedComponents}
                            isMulti
                            defaultValue={[]}
                            value={generateDropdown(props.class.props.filters.availableCities).filter(function(city) { return props.class.props.filters.cities.includes(city.value) })}
                            options={generateDropdown(props.class.props.filters.availableCities)} 
                            id="cities" 
                            onChange={ (choice) => props.class.handleFilterUpdate(choice,"cities") } 
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label>Bid History</label>
                        <div className="small text-muted">
                          <Select
                            closeMenuOnSelect={false}
                            components={props.class.props.animatedComponents}
                            isMulti
                            defaultValue={[]}
                            value={[{value: true, label:"Previously Worked With"}, {value: false, label:"No Previous Bids"}].filter(function(option) { return props.class.props.filters.previouslyAccepted.includes(option.value) })}
                            options={[{value: true, label:"Previously Worked With"}, {value: false, label:"No Previous Bids"}]} 
                            id="previouslyAccepted" 
                            onChange={ (choice) => props.class.handleFilterUpdate(choice,"previouslyAccepted") } 
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label>Genders:</label>
                        <div className="small text-muted">
                          <Select
                              closeMenuOnSelect={false}
                              components={props.class.props.animatedComponents}
                              isMulti
                              defaultValue={[]}
                              value={generateDropdown(props.class.props.filters.availableGenders).filter(function(gender) { return props.class.props.filters.genders.includes(gender.value) })}
                              options={generateDropdown(props.class.props.filters.availableGenders)} 
                              id="genders" 
                              onChange={ (choice) => props.class.handleFilterUpdate(choice,"genders") } 
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label>Primary Interests:</label>
                        <div className="small text-muted">
                          <Select
                              closeMenuOnSelect={false}
                              components={props.class.props.animatedComponents}
                              isMulti
                              defaultValue={[]}
                              value={generateDropdown(props.class.props.filters.availableInterests).filter(function(interest) { return props.class.props.filters.primaryInterests.includes(interest.value) })}
                              options={generateDropdown(props.class.props.filters.availableInterests)} 
                              id="primaryInterests" 
                              onChange={ (choice) => props.class.handleFilterUpdate(choice,"primaryInterests") } 
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Interests:</label>
                        <div className="small text-muted">
                          <Select
                              closeMenuOnSelect={false}
                              components={props.class.props.animatedComponents}
                              isMulti
                              defaultValue={[]}
                              value={generateDropdown(props.class.props.filters.availableInterests).filter(function(interest) { return props.class.props.filters.interests.includes(interest.value) })}
                              options={generateDropdown(props.class.props.filters.availableInterests)} 
                              id="interests" 
                              onChange={ (choice) => props.class.handleFilterUpdate(choice,"interests") } 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {props.class.props.showFilter == "moreAdvanced" && (
                    <>
                    <div className="mb-4">
                      <div className="mb-3">
                      </div>


                      <div className="mb-3">
                        <label className="me-1">Bidder Segments:</label>
                        <div className="small text-muted">
                          <Select
                              closeMenuOnSelect={false}
                              components={props.class.props.animatedComponents}
                              isMulti
                              defaultValue={[]}
                              value={[{value: "Digital First", label:"Digital First"}, {value: "Talent First", label:"Talent First"}, {value: "Creator", label:"Creator"}, {value: "Consumer", label:"Consumer"}].filter(function(segment) { return props.class.props.filters.segments.includes(segment.value) })}
                              options={[{value: "Digital First", label:"Digital First"}, {value: "Talent First", label:"Talent First"}, {value: "Creator", label:"Creator"}, {value: "Consumer", label:"Consumer"}]} 
                              id="segments" 
                              onChange={ (choice) => props.class.handleFilterUpdate(choice,"segments") } 
                          />
                        </div>
                      </div>
                    </div>

                    </>
                  )}
                  <div className="bottom-0 end-0 me-4 pe-1">
                  <>
                    {props.class.props.showFilter == "advanced" ? <button className="btn btn-sm btn-primary rounded-0 rounded-top border-0 m-0 fw-bold" onClick={() =>  props.class.props.setShowFilter("moreAdvanced")}>+ <span className="small">View More Filters</span></button> : <button className="btn btn-sm btn-primary rounded-0 rounded-top border-0 m-0 fw-bold" onClick={() =>  props.class.props.setShowFilter("advanced")}>- <span className="small">View Less Filters</span></button>}
                  </>
                  </div>  
                </div>
              </div>
            </>
            )}
          </Container>
        }
        <Container className="px-0 biddersList">
          {props.class.props.bidsTab === "pending" && 
            <Row className="p-3 pe-0 pendingBids">
              <div className="col-12">
                  <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                    {props.class.props.bids.map(bidder => <props.class.BidderCard key={bidder.details.bidderID} bidder={bidder} class={props.class} />)}
                  </Masonry>
              </div>
            </Row>
          }
          {props.class.props.bidsTab === "favourites" && 
          <Row className="p-3 pe-0 pendingBids">
              <div className="col-12">
                <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                  {favouriteBids.map(bidder => <props.class.BidderCard key={bidder.details.bidderID} bidder={bidder} class={props.class} />)}
                </Masonry>
              </div>
            </Row>
          }
          {props.class.props.bidsTab === "recommended" && 
          <Row className="p-3 pe-0 pendingBids">
              <div className="col-12">
                <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                  {recommendedBids.map(bidder => <props.class.BidderCard key={bidder.details.bidderID} bidder={bidder} class={props.class} />)}
                </Masonry>
              </div>
            </Row>
          }
          {props.class.props.bidsTab === "rejected" &&
            <Row className="p-3 pe-0 rejectedBids">
              <div className="col-12">
                  <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                    {props.class.props.rejectedBids.map(bidder => <props.class.BidderCard key={bidder.details.bidderID} bidder={bidder} class={props.class} />)}
                  </Masonry>
              </div>
            </Row>
          }
          {props.class.props.bidsTab === "cancelled" &&
            <Row className="p-3 pe-0 cancelledBids">
              <div className="col-12">
                  <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                    {props.class.props.cancelledBids.map(bidder => <props.class.BidderCard key={bidder.details.bidderID} bidder={bidder} class={props.class} />)}
                  </Masonry>
              </div>
            </Row>
          }
        </Container>
        <props.class.ApprovalModal handleClose={handleAcceptClose} show={props.showAcceptModal} class={props.class} setReason={props.setReason} reason={props.reason}/>
        <props.class.RejectModal handleClose={handleRejectClose} show={props.showRejectModal} class={props.class} setReason={props.setReason} reason={props.reason} />
        <props.class.SavedFiltersModal class={props.class}/>
        {["pending","recommended","favourites"].includes(props.class.props.bidsTab) && 
          <Container className="bg-background shadow position-fixed bottom-0 z-index-9 border-top pb-0" fluid>
            <Container className="px-0 py-3">
              <Row>
                {(props.class.props.maxAcceptedBids > 0 && props.class.props.acceptedBids.length >= props.class.props.maxAcceptedBids) && <div className="col-6 text-muted"><b>Maximum number of bids accepted. Please contact your account manager or email <a href="mailto:customer.success@thelxroom.com">customer.success@thelxroom.com</a> to discuss options</b></div>}
                {props.class.props.maxAcceptedBids < 0 && <div className="col-6 text-muted"><b>Accepting bids is currently disabled. Please contact your account manager or email <a href="mailto:customer.success@thelxroom.com">customer.success@thelxroom.com</a> to discuss options</b></div>}
                <div className={(props.class.props.maxAcceptedBids > 0 && props.class.props.acceptedBids.length >= props.class.props.maxAcceptedBids) ? "col-6 text-end" : "col-12 text-end"}>
                    <button className="btn btn-outline-danger btn-sm me-3" disabled={Object.keys(props.selectBids).length == 0} onClick={handleRejectShow}>Decline {Object.keys(props.selectBids).length} {Object.keys(props.selectBids).length == 1 ? "Bid " : "Bids"}</button>
                    {(props.class.props.maxAcceptedBids == 0 || (props.class.props.maxAcceptedBids > 0 && props.class.props.acceptedBids.length < props.class.props.maxAcceptedBids)) &&
                      <button className="btn btn-success btn-sm me-md-3 me-lg-0" disabled={props.class.props.maxAcceptedBids < 0 || Object.keys(props.selectBids).length == 0 || (props.class.props.maxAcceptedBids > 0 && Object.keys(props.selectBids).length + props.class.props.acceptedBids.length > props.class.props.maxAcceptedBids)} onClick={handleAcceptShow}>Approve {Object.keys(props.selectBids).length} {Object.keys(props.selectBids).length == 1 ? "Bid " : "Bids"}</button>
                    }
                </div>
              </Row>
            </Container>
          </Container>
        }
      </>
    )
  }

  updateCollaborationsSearch(text) {
    var filters = this.props.filters;
    filters.collaborationsSearch = text.toLowerCase();
    this.props.setFilters(filters);
    setFilter(filters,"collaborator")
    this.props.setFilteredCollaborators(this.state.campaign.collaborators.filter(function(collaborator) {return collaborator.profile.name.toLowerCase().includes(text.toLowerCase()) || text.length == 0}))
  }

  performBulkMessage(selection){
      var recipients = [];
      this.props.conversations.conversations.filter(function(conversation) { return conversation.bidDetails && conversation.bidDetails.state.toLowerCase() == selection }).forEach(conversation =>{
        var recipient = null;
        conversation.participants.forEach(function (participant) {
          if (!participant.hasOwnProperty("me")){
            recipient = participant.details
          }
        })
        recipients.push({"recipient":recipient,"conversationID":conversation._id}) 
        })
      this.props.setBulkMessage({"visible":true,"recipients":recipients});
      this.props.setTabID("messages")
      this.props.setUpdateCounter(this.props.updateCounter + 1)
  }

  CollaborationsView(props) {
    const accepted = props.class.props.filteredCollaborators.filter(function(collaborator) { return collaborator.details.state == "Accepted" })
    const inProgress = props.class.props.filteredCollaborators.filter(function(collaborator) { return collaborator.details.state == "In Progress" })
    const markedAsComplete = props.class.props.filteredCollaborators.filter(function(collaborator) { return collaborator.details.state == "Marked as Complete" }).sort((a,b) => {return a.details.completionTime - b.details.completionTime})
    const completed = props.class.props.filteredCollaborators.filter(function(collaborator) { return collaborator.details.state == "Completed" }).sort((a,b) => {return a.details.completionTime - b.details.completionTime})

    const breakpointColumnsObj = {
      default: 3,
      1100: 2,
      700: 1
    }

    return (
      <Container className="px-0 pt-2">
      <props.class.CancelModal show={props.class.props.showCancelModal} class={props.class} setReason={props.class.props.setReason} reason={props.class.props.reason} />
      <props.class.CompletionModal show={props.class.props.showCompletionModal} class={props.class} setReason={props.class.props.setReason} reason={props.class.props.reason} />
      <props.class.ConversationModal class={props.class} message={false} />
      <Row>
        <div className="col-12">
          <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade" id="all" role="tabpanel" aria-labelledby="all-tab">...</div>
            <div className="tab-pane fade show active" id="collaborations" role="tabpanel" aria-labelledby="collaborations-tab">

              <Row className="pt-2 position-relative">

                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className="searchBoxCollaborations me-3 desktopView">
                    <InputGroup className="shadow-sm">
                      <Form.Control placeholder="Search" className="border-end-0 form-control-sm" aria-label="Search" defaultValue={props.class.props.filters.collaborationsSearch} onChange={e => props.class.updateCollaborationsSearch(e.target.value)} />
                      <InputGroup.Text className="bg-background border-end">
                        <a><img src={searchBlue} /></a>
                      </InputGroup.Text>
                    </InputGroup>
                  </div>
                  <Tabs defaultActiveKey="accepted" className="ps-3" id="uncontrolled-tab-example" >
                    <Tab eventKey="accepted" disabled={accepted.length == 0} title={`Accepted (${accepted.length})`}>
                      <div className="mt-3 d-block ps-3">
                        {accepted.length > 0 && <a onClick={() => props.class.performBulkMessage("accepted")} className="small">Send Bulk Message</a>}
                      </div>
                      <div className="collaborationsList px-3 mt-3">
                        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                          {accepted.map(collaborator => <props.class.CollaboratorCard key={collaborator.details.bidderID} collaborator={collaborator} class={props.class} selectMessage={props.selectMessage} campaign={props.campaign} />)}
                        </Masonry>
                      </div>
                    </Tab>
                    <Tab eventKey="inprogress" disabled={inProgress.length == 0} title={`In Progress (${inProgress.length})`}>
                      <div className="mt-3 d-block ps-3">
                        {inProgress.length > 0 && <a onClick={() => props.class.performBulkMessage("in progress")} className="small">Send Bulk Message</a>}
                      </div>
                      <div className="collaborationsList px-3 mt-3">
                        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                          {inProgress.map(collaborator => <props.class.CollaboratorCard key={collaborator.details.bidderID} collaborator={collaborator} class={props.class} campaign={props.campaign} />)}
                        </Masonry>
                      </div>
                    </Tab>
                    <Tab eventKey="markedAsComplete" disabled={markedAsComplete.length == 0} title={`Marked as Complete (${markedAsComplete.length})`}>
                      {markedAsComplete.length > 0 && <a onClick={() => props.class.performBulkMessage("marked as complete")} className="small mt-3 d-block ps-3">Send Bulk Message</a>}
                      <div className="collaborationsList px-3 mt-3 markedAsComplete">
                        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                          {markedAsComplete.map(collaborator => <props.class.CollaboratorCard key={collaborator.details.bidderID} collaborator={collaborator} class={props.class} campaign={props.campaign} />)}
                        </Masonry>
                      </div>
                    </Tab>
                    <Tab eventKey="completed" disabled={completed.length == 0} title={`Completed (${completed.length})`}>
                      {completed.length > 0 && <a onClick={() => props.class.performBulkMessage("completed")} className="small mt-3 d-block ps-3">Send Bulk Message</a>}
                      <div className="collaborationsList px-3 mt-3 completed">
                        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                          {completed.map(collaborator => <props.class.CollaboratorCard key={collaborator.details.bidderID} collaborator={collaborator} class={props.class} campaign={props.campaign} />)}
                        </Masonry>
                      </div>
                    </Tab>
                  </Tabs>
                </Col>

              </Row>
            </div>
          </div>
        </div>
      </Row>
    </Container>
    )
  }
  
  ReportingView(props) {
    return (
      <Container className="py-4 reportingTab">
        <div className="mb-3 bg-background p-3 rounded border shadow-sm">
          <h3 className="font-bold text-neutral capitalize">Bidder Data</h3>
          <p data-testid="campaign-stats-description">View profiles of all bidders on this listing.</p>
          <div role="group">
              <Button onClick={e => props.class.getReport("bidder")} size="sm" className="me-3">Download All</Button>
              <Button onClick={e => props.class.getReport("favourites")} size="sm" className="me-3">Download Favourites</Button>
              {(props.class.props.currentProfile.profile?.features?.includes("influencerRecommendations") || props.class.props.currentProfile.profile?.features?.includes("all")) && (
                <>
                  <Button onClick={e => props.class.getReport("recommended")} size="sm" className="me-3">Download Recommended</Button>
                  <Button onClick={e => props.class.getReport("favourites&recommended")} size="sm">Download Favourites & Recommended</Button>
                </>
              )}
          </div>
        </div>
        <div className="mb-3 bg-background p-3 rounded border shadow-sm">
          <h3 className="font-bold text-neutral capitalize">Member Contact Details</h3>
          <p data-testid="campaign-stats-description">Downloads contact details (address, phone number etc) for all accepted bidders on this listing.</p>
          <div className="btn-group" role="group">
            <Button onClick={e => props.class.getReport("collaborator")} size="sm">Download</Button>
          </div>
        </div>
      </Container>
    )
  }

  updateNotificationTargets(props){
    this.props.setCustomNotificationTargets([])
    if (props.includes("All") || props.includes("Custom")){
      if (props.slice(-1) == "All" || props.slice(-1) == "Custom"){
        this.props.setNotificationTargets(props.slice(-1))
      }
      else {
        this.props.setNotificationTargets(props.slice(1))
      }
    }
    else {
      this.props.setNotificationTargets(props)
    }
  }

  updateNotificationMessage(props){
    var message = structuredClone(this.props.notificationMessage);
    message[props.target.id] = props.target.value; 
    this.props.setNotificationMessage(message)
  }

  async sendNotification(){
    var response = await apiCall(`notification/custom`,{ "method" : "POST", "data" : {"type":"campaign","id":this.props.id,"targets":this.props.notificationTargets,"details":{"customTargets":this.props.customNotificationTargets.map(target => target.value),"message":this.props.notificationMessage}} });
    if (response["success"]) {
      this.props.setAlert({"display":"toast","visible":true,"title":"Notification Sent","content":"A Notification was sent to all targeted influencers","className":"bg-success text-background"})
    }
    else {
      this.props.setAlert({"display":"toast","visible":true,"title":"Error Sending Notification","content":response["failure"]["error"],"className":"bg-danger text-background"})
    };
  }

  updateNotificationsSearch(text) {
    var filters = this.props.notificationFilters;
    filters.search = text.toLowerCase();
    this.props.setNotificationFilters(Object.assign({}, this.props.notificationFilters, filters));
    setFilter(filters,"notification")
  }

  updateAllNotifications = async (event,result) => {
    result = await result;
    if (event.pageData.page >= 1) {
      for (var x in result["notifications"]) {
        this.props.allNotifications.push(result["notifications"][x])  
      }
      this.props.setAllNotifications([...this.props.allNotifications])
    } 
    else {
      this.props.setAllNotifications(result["notifications"])
    }
  }

  NotificationsView(props) {
    var allBidders = props.class.props.bids.map(bidder => ({"label":`${bidder.profile.name} (${bidder.details.state})`,"value":bidder.details.bidderID}))
    allBidders.push(
      ...props.class.props.filteredCollaborators.map(bidder => ({"label":`${bidder.profile.name} (${bidder.details.state})`,"value":bidder.details.bidderID})),
      ...props.class.props.rejectedBids.map(bidder => ({"label":`${bidder.profile.name} (${bidder.details.state})`,"value":bidder.details.bidderID})),
      ...props.class.props.cancelledBids.map(bidder => ({"label":`${bidder.profile.name} (${bidder.details.state})`,"value":bidder.details.bidderID})),
    )
    return (
      <Container fluid className="notificationTab pb-0">
        <Container className="py-4 pb-0">
          <Row className="mx-0">
            <Col xs={12} md={12} lg={12} xl={5}>
              <div className="bg-background p-4 rounded border shadow-sm sendNotification">
                <h4 className="font-bold text-capitalize">Send a Listing Notification</h4>
                <p className="small text-muted">Send a notification to selected Members about this listing.</p>
                <div className="form-group my-4 notificationTargets">              
                  <ToggleButtonGroup type="checkbox" value={props.class.props.notificationTargets} onChange={e => props.class.updateNotificationTargets(e)} id="notificationTargetType">
                    <ToggleButton id="notificationTargetType-1" className="me-2 mb-2" value="All">All</ToggleButton>
                    <ToggleButton id="notificationTargetType-2" className="me-2 mb-2" value="Pending">Pending</ToggleButton>
                    <ToggleButton id="notificationTargetType-3" className="me-2 mb-2" value="Accepted">Accepted</ToggleButton>
                    <ToggleButton id="notificationTargetType-4" className="me-2 mb-2" value="In Progress">In Progress</ToggleButton>
                    <ToggleButton id="notificationTargetType-5" className="me-2 mb-2" value="Marked as Complete">Marked as Complete</ToggleButton>
                    <ToggleButton id="notificationTargetType-6" className="me-2 mb-2" value="Completed">Completed</ToggleButton>
                    <ToggleButton id="notificationTargetType-7" className="me-2 mb-2" value="Cancelled">Cancelled</ToggleButton>
                    <ToggleButton id="notificationTargetType-8" className="me-2 mb-2" value="Rejected">Declined</ToggleButton>
                    <ToggleButton id="notificationTargetType-9" className="me-2 mb-2" value="Custom">Custom</ToggleButton>
                  </ToggleButtonGroup>
                  {props.class.props.notificationTargets.includes("Custom") && 
                    <Select
                        className="my-2"
                        closeMenuOnSelect={false}
                        components={props.class.props.animatedComponents}
                        isMulti
                        defaultValue={[]}
                        value={props.class.props.customNotificationTargets}
                        options={allBidders} 
                        id="customNotificationTargets" 
                        onChange={ (choice) => {props.class.props.setCustomNotificationTargets(choice)} } 
                      />
                  }
                  <span className="small text-muted d-block">Select members from the above groups or select custom to specific members directly</span>  
                </div>
                <div className="form-group mb-3 position-relative">
                    <input type="text" maxLength="50" className="form-control pe-5" value={props.class.props.notificationMessage.title} onChange={e => props.class.updateNotificationMessage(e)} id="title" placeholder="Write your message here"></input>
                </div>
                <div className="form-group mb-3 position-relative">
                    <textarea type="text" rows="6" maxLength="500" className="form-control pe-5" value={props.class.props.notificationMessage.body} onChange={e => props.class.updateNotificationMessage(e)} id="body" placeholder="Write a longer description for users to read once they've clicked on the notification"></textarea>
                </div>
                <div className="btn-group" role="group">
                    <Button onClick={e => props.class.sendNotification()} size="sm">Send</Button>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={12} xl={7}>              
              <div className="py-4 notificationHistory">
                <div className="p-3 d-flex align-items-center justify-content-between">
                  <h4 className="font-bold text-capitalize mb-3">Notification History</h4>
                  <div className="d-flex align-items-center justify-content-end">
                    <InputGroup size="sm" className="me-3">
                      <Form.Control placeholder="Search" className="border-end-0" aria-label="Search" defaultValue={props.class.props.notificationFilters.search} onChange={e => props.class.updateNotificationsSearch(e.target.value)} />
                      <InputGroup.Text className="bg-background border-end">
                        <a><img src={searchBlue} /></a>
                      </InputGroup.Text>
                    </InputGroup>
                  </div>
                </div>
                <div className="me-lg-2">
                  <table className="table border-transparent">
                    <thead className="small">
                      <tr>
                        <th>Message</th>
                        <th>Receiver</th>
                        <th>Time</th>
                        <th>Type</th>
                      </tr>
                    </thead>
                    <tbody className="small">
                      {props.class.props.allNotifications.map(notification => (
                        <tr key={notification._id}>
                          <td>{notification.data.details}</td>
                          <td>{notification.data.influencerName}</td>
                          <td>{notification.createdAt}</td>
                          <td>
                            <Row>
                              {notification.notifications.map((notificationType) => {
                                switch(notificationType.type) {
                                  case "web":
                                    return (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-globe my-1" viewBox="0 0 16 16">
                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472M3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"/>
                                        <title>Web</title>
                                      </svg>
                                    )
                                  case "email":
                                    return (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-at my-1" viewBox="0 0 16 16">
                                        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"/>
                                        <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/>
                                        <title>Email</title>
                                      </svg>
                                    )
                                  case "mobile":
                                    return (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-phone my-1" viewBox="0 0 16 16">
                                        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                                        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                                        <title>Mobile</title>
                                      </svg>
                                    )
                                }
                              })}
                            </Row>
                          </td>
                        </tr>
                      ))}
                      <PageScroller endpoint="notification/history" setState={props.class.updateAllNotifications} filter={props.class.props.notificationFilters} pageSize={25} />
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    )
  }

  async muteBid(bidID){
    var response = await apiCall(`campaign/bid/mute?id=${this.props.id}`,{ "method" : "PUT", "data" : {"bidID":bidID} });
    if (response["success"]) {
      this.props.setAlert({"display":"toast","visible":true,"title":"Bid Muted","content":"This members bid has been muted and will not appear directly in future listings","className":"bg-success text-background"})
      this.getCampaign(this.props.id)
    }
    else {
      this.props.setAlert({"display":"toast","visible":true,"title":"Could not mute bid","content":response["failure"]["error"],"className":"bg-danger text-background"})
    };
  }

  async unmuteBid(bidID){
    var response = await apiCall(`campaign/bid/unmute?id=${this.props.id}`,{ "method" : "PUT", "data" : {"bidID":bidID} });
    if (response["success"]) {
      this.props.setAlert({"display":"toast","visible":true,"title":"Bid Muted","content":"This members bid has been unmuted and they will appear again in future listings","className":"bg-success text-background"})
      this.getCampaign(this.props.id)
    }
    else {
      this.props.setAlert({"display":"toast","visible":true,"title":"Could not unmute bid","content":response["failure"]["error"],"className":"bg-danger text-background"})
    };
  }

  async favouriteBid(bidID){
    var response = await apiCall(`campaign/bid/favourite?id=${this.props.id}`,{ "method" : "PUT", "data" : {"bidID":bidID} });
    if (response["success"]) {
      this.props.setAlert({"display":"toast","visible":true,"title":"Bid Favourited","content":"Bid was successfully favourited","className":"bg-success text-background"})
      this.getCampaign(this.props.id)
    }
    else {
      this.props.setAlert({"display":"toast","visible":true,"title":"Could not favourite bid","content":response["failure"]["error"],"className":"bg-danger text-background"})
    };
  }

  async unfavouriteBid(bidID){
    var response = await apiCall(`campaign/bid/unfavourite?id=${this.props.id}`,{ "method" : "PUT", "data" : {"bidID":bidID} });
    if (response["success"]) {
      this.props.setAlert({"display":"toast","visible":true,"title":"Bid Unfavourited","content":"Bid was successfully unfavourited","className":"bg-success text-background"})
      this.getCampaign(this.props.id)
    }
    else {
      this.props.setAlert({"display":"toast","visible":true,"title":"Could not unfavourite bid","content":response["failure"]["error"],"className":"bg-danger text-background"})
    };
  }

  render() {
    const { error, isLoaded, campaign, open } = this.state;

    const changeTab = (tabName) => {
      let currentUrlParams = new URLSearchParams(window.location.search);
      currentUrlParams.set('view', tabName);
      let newUrl = window.location.origin + window.location.pathname + '?' + currentUrlParams.toString();
      window.history.replaceState({path:newUrl},'',newUrl);
      this.props.setAutoScroll(true);
    }

    if (error) {
      return <div className="text-danger text-center h-100 d-flex align-items-center justify-content-start px-4 px-md-0 py-5 flex-column fs-5 bg-secondary"><img src={NoAccess} className="noAccessImg my-5 rounded-xl shadow" /><div>Error: {error}</div></div>;
    } else if (!isLoaded) {
      return <FullPageSpinner />;
    } else {
      return (
        <Container className="fullscreenWithTopBar px-0 campaignPage" fluid>
          <Tab.Container id="campaign-tab" activeKey={this.props.tabID} onSelect={(key) => this.props.setTabID(key)}>
            <Container className="pageTitleContainer px-0 shadow-sm pb-0" fluid>
              <Container className="border-bottom pb-0" fluid>
                <Container className="px-0">
                  <Row className="px-3">
                    <Col xs={7}>
                      <div className="pt-3 mb-3">
                        <Link to="/Campaigns" className="text-light"><svg width="15" height="13" className="align-middle me-1" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.157595 5.79154L3.5281 9.88415C3.80704 10.1963 4.25408 10.2261 4.54761 9.98575C4.84116 9.74544 4.88952 9.25978 4.64905 8.96624L2.249 6.05465L12.2777 6.05465C12.6766 6.05465 13 5.73122 13 5.33237C13 4.93353 12.6766 4.6101 12.2777 4.6101L2.249 4.6101L4.64905 1.69851C4.88935 1.40513 4.83528 0.92619 4.54762 0.678997C4.25088 0.424079 3.76842 0.487055 3.52811 0.780596L0.157595 4.87321C-0.0618908 5.1817 -0.0430826 5.4927 0.157595 5.79113L0.157595 5.79154Z" fill="var(--lightColor)"/></svg> My Listings</Link>
                      </div>
                      <Nav variant="tabs" className="nav nav-tabs border-0">
                        <Nav.Item>
                          <Nav.Link className="bg-transparent" eventKey="bids" onClick={()=>changeTab("bids")}>Bids {campaign.pendingBids.length > 0 && <Badge bg="primary">{campaign.pendingBids.length}</Badge>}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link className="bg-transparent" eventKey="collaborations" onClick={()=>changeTab("collaborations")}>Collaborations {campaign.collaborators.filter(function(collaborator) {return collaborator.state == "Marked as Complete"}).length > 0 && <Badge bg="danger">{campaign.collaborators.filter(function(collaborator) {return collaborator.state == "Marked as Complete"}).length}</Badge>}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link className="bg-transparent" eventKey="messages" onClick={()=>changeTab("messages")}>Messages {this.props.unreadMessages > 0 && <Badge bg="danger">{this.props.unreadMessages}</Badge>}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link className="bg-transparent" eventKey="reporting" onClick={()=>changeTab("reporting")}>Reporting</Nav.Link>
                        </Nav.Item>
                        {(this.props.currentProfile.type == "admins" || this.props.session.sessionType == "impersonation") && 
                          <Nav.Item>
                            <Nav.Link className="bg-transparent" eventKey="notifications" onClick={()=>changeTab("notifications")}>Notifications</Nav.Link>
                          </Nav.Item>
                        }
                      </Nav>
                    </Col>
                    <Col xs={5} className="d-flex align-items-center">
                      <img src={getImageUrl(this.props.providers,campaign.images[0],["w_100","c_scale"])} alt="campaignImage" height="40px" width="70px" className="rounded object-fit-cover me-3" />
                      <div className="text-truncate">
                        <div className="d-flex align-items-center mb-0">
                          <h1 className="pageTitle secondaryHeadingsFont mb-0 text-truncate me-2">{campaign.name}</h1>
                          {campaign.campaignType && (
                            <span className="badge bg-info text-capitalize">{campaign.campaignType}</span>
                          )}
                        </div>
                        <Link to={"/Campaign/Preview?id="+campaign._id} className="text-light">Preview Listing</Link>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </Container>
            <Container className="d-block d-md-none px-0 bg-background pb-0" fluid>
              <Container className="border-bottom pb-0" fluid>
                <Container className="ps-3 pt-4 pe-0 shadow">
                  <Row className="mx-0">
                    <Col xs={12} className="pt-3 mb-3 px-0">
                      <Link to="/Campaigns" className="text-muted"><svg width="15" height="13" className="align-middle me-1" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.157595 5.79154L3.5281 9.88415C3.80704 10.1963 4.25408 10.2261 4.54761 9.98575C4.84116 9.74544 4.88952 9.25978 4.64905 8.96624L2.249 6.05465L12.2777 6.05465C12.6766 6.05465 13 5.73122 13 5.33237C13 4.93353 12.6766 4.6101 12.2777 4.6101L2.249 4.6101L4.64905 1.69851C4.88935 1.40513 4.83528 0.92619 4.54762 0.678997C4.25088 0.424079 3.76842 0.487055 3.52811 0.780596L0.157595 4.87321C-0.0618908 5.1817 -0.0430826 5.4927 0.157595 5.79113L0.157595 5.79154Z" fill="#8D8D8D"/></svg> My Listings</Link>
                    </Col>
                    <Col xs={12} className="mb-3 px-0 d-flex align-items-center">
                      <img src={getImageUrl(this.props.providers,campaign.images[0],["w_80","h_80","c_scale"])} alt="campaignImage" height="40px" width="40px" className="rounded object-fit-cover me-2" />
                      <div className="w-100 text-truncate me-3">
                        <div className="d-flex align-items-center mb-0">
                          <h1 className="pageTitle mb-0 fs-6 ps-0 me-2">{campaign.name}</h1>
                          {campaign.campaignType && (
                            <span className="badge bg-info text-capitalize">{campaign.campaignType}</span>
                          )}
                        </div>
                        <Link className="small" to={"/Campaign/Preview?id="+campaign._id}>Preview listing</Link>
                      </div>
                    </Col>
                    <Col xs={12} className="px-0">
                        <Nav variant="tabs" className="nav nav-tabs border-0 flex-nowrap overflow-auto">
                          <Nav.Item>
                            <Nav.Link className="text-nowrap" eventKey="bids" onClick={()=>changeTab("bids")}>Bids {campaign.pendingBids.length > 0 && <Badge bg="danger" className="align-middle">{campaign.pendingBids.length}</Badge>}</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link className="text-nowrap" eventKey="collaborations" onClick={()=>changeTab("collaborations")}>Collaborations {campaign.collaborators.filter(function(collaborator) {return collaborator.state == "Marked as Complete"}).length && <Badge bg="danger" className="align-middle">{campaign.collaborators.filter(function(collaborator) {return collaborator.state == "Marked as Complete"}).length}</Badge>}</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link className="text-nowrap" eventKey="messages" onClick={()=>changeTab("messages")}>Messages {campaign.unreadMessages > 0 && <Badge bg="danger" className="align-middle">{campaign.unreadMessages}</Badge>}</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link className="text-nowrap" eventKey="reporting" onClick={()=>changeTab("reporting")}>Reporting</Nav.Link>
                          </Nav.Item>
                          {(this.props.currentProfile.type == "admins" || this.props.session.sessionType == "impersonation") && 
                            <Nav.Item>
                              <Nav.Link className="text-nowrap" eventKey="notifications" onClick={()=>changeTab("notifications")}>Notifications</Nav.Link>
                            </Nav.Item>
                          }
                        </Nav>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </Container>
            <Tab.Content className="chatContainer">
              <Tab.Pane eventKey="bids" className={this.props.bidsTab !== "pending" ? "noButton" : ""}>
                <this.BidsView campaign={campaign} class={this} open={open} selectBids={this.props.selectBids} setSelectBids={this.props.setSelectBids} reason={this.props.reason} setReason={this.props.setReason} showAcceptModal={this.props.showAcceptModal} setShowAcceptModal={this.props.setShowAcceptModal}  showRejectModal={this.props.showRejectModal} setShowRejectModal={this.props.setShowRejectModal} setSavedFilters={this.props.setSavedFilters} savedFilters={this.props.savedFilters} />
              </Tab.Pane>
              <Tab.Pane eventKey="collaborations">
                <this.CollaborationsView campaign={campaign} class={this} open={open}/>
              </Tab.Pane>
              <Tab.Pane eventKey="messages" className="h-100">
                <Container className="px-0 pt-md-4 h-100 pb-0" fluid>
                  <Container className="px-0 h-100">
                    <Conversation chatBox={this.props.chatBox} setChatBox={this.props.setChatBox} campaignID={campaign._id} class={this} providers={this.props.providers} setTabID={this.props.setTabID} campaign={campaign} />
                  </Container>
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="reporting">
                                <this.ReportingView class={this}  campaignID={campaign._id} />

              </Tab.Pane>
              {(this.props.currentProfile.type == "admins" || this.props.session.sessionType == "impersonation") && 
                <Tab.Pane eventKey="notifications">
                  <this.NotificationsView class={this} />
                </Tab.Pane>
              }
            </Tab.Content>
          </Tab.Container>
        </Container>
      )
  }
  }
}

export default function MyCampaign() {
  let [searchParams] = useSearchParams();
  const animatedComponents = makeAnimated();
  const campaignID = searchParams.get('id');
  var view = searchParams.get('view');
  if (view == null){
    view = "bids";
  }
  const conversation = searchParams.get('conversation_id');
  const [tabID, setTabID] = useState(view);
  const [bidsTab, setBidsTab] = useState("pending");
  const [conversationID, setConversationID] = useState(conversation);
  const [selectBids, setSelectBids] = useState({});
  const [selectAllBids, setSelectAllBids] = useState(false)
  const [selectRecommendedBids, setSelectRecommendedBids] = useState(false)
  const [chatBox, setChatBox] = useState(false);
  const [showFilter, setShowFilter] = useState("simple");
  const [savedFilters, setSavedFilters] = useState({"visible":false,"selected":null,"filters":{}});
  const [filters, setFilters] = useState({"cities":[],"availableCities":[],"genders":[],"availableGenders":[],"previousBidderOnly":false,"ages":{"min":18,"max":100},fee: { minFee: "", maxFee: "" },"search":"","interests":[],"availableInterests":[],"collaborationsSearch" : "","segments":[],"muted":false,"favourite":false,"previouslyAccepted":[],"primaryInterests":[]});
  const [sortBy, setSortBy] = useState("createdAt");
  const [orderBy, setOrderBy] = useState("ascending");
  const [conversations, setConversations] = useState({"conversations":[],"conversation":null,"messages":[]})
  const [bids, setBids] = useState([]);
  const [rejectedBids, setRejectedBids] = useState([]);
  const [cancelledBids, setCancelledBids] = useState([]);
  const [ acceptedBids, setAcceptedBids ] = useState([]);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showCancelModal, setCancelModal] = useState({"visible":false,"collaborator":null})
  const [showCompletionModal, setCompletionModal] = useState({"visible":false,"collaborator":null})
  const [reason, setReason] = useState(null)
  const [showAlert, setAlert] = useState({"display":"toast","visible":false,"title":"","content":""});
  const hideAlert = () => setAlert({"display":"toast","visible":false,"title":"","content":""});
  const { providers } = useImageContext();
  const [unreadMessages,setUnreadMessages] = useState(0)
  const [ filterUnreadMessages, setFilterUnreadMessages ] = useState(false);
  const [conversationModal, setConversationModal] = useState({"visible":false,"conversationID":null,"user":null,"conversation":null,"messages":[]});
  const [openCards, setOpenCards] = useState({});
  const [collaboratorSearch, setCollaboratorSearch] = useState("");
  const [filteredCollaborators, setFilteredCollaborators] = useState([]);
  const [subscription, setSubscription] = useState({"package":"self-serve"});
  const [ autoScroll, setAutoScroll ] = useState(true);
  const [updateCounter, setUpdateCounter] = useState(0)
  const [contextMenu, setContextMenu] = useState({"x":0,"y":0,"visible":false})
  const { currentProfile, session } = useAuthContext();
  const [ bulkMessage, setBulkMessage ] = useState({"visible":false,"recipients":[]})
  const [showCarousel, setShowCarousel] = useState({"visible":false,"image":null});
  const [ filterTimer, setFilterTimer ] = useState(null); 
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ notificationTargets, setNotificationTargets ] = useState(["All"]);
  const [ notificationMessage, setNotificationMessage ] = useState({"title":"","body":""});
  const [ customNotificationTargets, setCustomNotificationTargets ] = useState([])
  const [ allNotifications, setAllNotifications ] = useState([])
  const [ maxAcceptedBids, setMaxAcceptedBids ] = useState(0)
  const [ notificationFilters, setNotificationFilters] = useState({"search":""});
  const [inboxFilters, setInboxFilters] = useState({"search":"","archived":false,"deliveryState":""});
  const [viewMarkAllAsReadModal, setViewMarkAllAsReadModal] = useState(false);
  



const hasInitialisedFees = useRef(false);

useEffect(() => {
  if (!bids || bids.length === 0) return;
  if (hasInitialisedFees.current) return;
  
  const fees = bids
    .map(bid => Number(bid?.details?.fee ?? bid?.details?.proposedFee ?? 0))
    .filter(fee => !isNaN(fee) && fee > 0);
  
  if (fees.length === 0) return;
  
  hasInitialisedFees.current = true;
  
  setFilters(prev => ({
    ...prev,
    fee: {
      minFee: Math.min(...fees),
      maxFee: Math.max(...fees)
    }
  }));
}, [bids]);

  return (
    <div className="bg-page">
      <Topbar />
      <div className="pageName">My Listings</div>
      <AlertModal modal={showAlert} onClose={hideAlert} />
      <CampaignManageView id={campaignID}   
      showAcceptModal={showAcceptModal} 
      setShowAcceptModal={setShowAcceptModal} 
      tabID={tabID} 
      setTabID={setTabID}
       bidsTab={bidsTab}
        setBidsTab={setBidsTab} 
        chatBox={chatBox} 
        setChatBox={setChatBox}
        selectBids={selectBids}
        setSelectBids={setSelectBids}
        reason={reason}
        setReason={setReason}
        selectAllBids={selectAllBids}
        setSelectAllBids={setSelectAllBids}
        selectRecommendedBids={selectRecommendedBids}
        setSelectRecommendedBids={setSelectRecommendedBids}
        setSortBy={setSortBy}
        sortBy={sortBy}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        bids={bids}
        setBids={setBids}
        rejectedBids={rejectedBids}
        setRejectedBids={setRejectedBids}
        cancelledBids={cancelledBids}
        setCancelledBids={setCancelledBids}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        filters={filters}
        setFilters={setFilters}
        animatedComponents={animatedComponents}
        conversationID={conversationID}
        setConversationID={setConversationID}
        conversations={conversations}
        setConversations={setConversations}
        showRejectModal={showRejectModal}
        setShowRejectModal={setShowRejectModal}
        setAlert={setAlert}
        providers={providers}
        openCards={openCards}
        setOpenCards={setOpenCards}
        showCancelModal={showCancelModal}
        setCancelModal={setCancelModal}
        conversationModal={conversationModal}
        setConversationModal={setConversationModal}
        filteredCollaborators={filteredCollaborators}
        setFilteredCollaborators={setFilteredCollaborators}
        collaboratorSearch={collaboratorSearch}
        setCollaboratorSearch={setCollaboratorSearch}
        unreadMessages={unreadMessages}
        setUnreadMessages={setUnreadMessages}
        subscription={subscription}
        setSubscription={setSubscription}
        showCompletionModal={showCompletionModal}
        setCompletionModal={setCompletionModal}
        autoScroll={autoScroll}
        setAutoScroll={setAutoScroll}
        filterUnreadMessages={filterUnreadMessages}
        setFilterUnreadMessages={setFilterUnreadMessages}
        currentProfile={currentProfile}
        session={session}
        updateCounter={updateCounter}
        setUpdateCounter={setUpdateCounter}
        bulkMessage={bulkMessage}
        setBulkMessage={setBulkMessage}
        contextMenu={contextMenu}
        setContextMenu={setContextMenu}
        showCarousel={showCarousel}
        setShowCarousel={setShowCarousel}
        filterTimer={filterTimer}
        setFilterTimer={setFilterTimer}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
        notificationTargets={notificationTargets}
        setNotificationTargets={setNotificationTargets}
        notificationMessage={notificationMessage}
        setNotificationMessage={setNotificationMessage}
        customNotificationTargets={customNotificationTargets}
        setCustomNotificationTargets={setCustomNotificationTargets}
        acceptedBids={acceptedBids}
        setAcceptedBids={setAcceptedBids}
        allNotifications={allNotifications}
        setAllNotifications={setAllNotifications}
        notificationFilters={notificationFilters}
        setNotificationFilters={setNotificationFilters}
        inboxFilters={inboxFilters}
        setInboxFilters={setInboxFilters}
        viewMarkAllAsReadModal={viewMarkAllAsReadModal}
        setViewMarkAllAsReadModal={setViewMarkAllAsReadModal}
        savedFilters={savedFilters}
        setSavedFilters={setSavedFilters}
        maxAcceptedBids={maxAcceptedBids}
        setMaxAcceptedBids={setMaxAcceptedBids}
      />
      <Footer />
    </div>
  );
}